import { PLATFORM_ADMIN_ROLE_NAMES as e } from "@teletienda/shared-utils-lib";
import { create as t } from "zustand";
import { createJSONStorage as n, persist as r } from "zustand/middleware";
import i, { HTTPError as a } from "ky";
import o, { createContext as s, useCallback as c, useContext as l, useEffect as u, useMemo as d, useRef as f, useState as p } from "react";
import { Alert as m, Anchor as h, Avatar as g, Box as _, Button as v, Center as y, Checkbox as b, Divider as x, Group as S, Loader as C, Menu as w, Modal as T, Paper as E, PasswordInput as D, Progress as O, SegmentedControl as k, Stack as A, Text as j, TextInput as ee, ThemeIcon as te, Title as ne, UnstyledButton as M, useComputedColorScheme as N, useMantineTheme as re } from "@mantine/core";
import { useForm as ie } from "@mantine/form";
import { IconAlertCircle as P, IconArrowLeft as ae, IconBrandFacebook as oe, IconBrandGoogle as se, IconCheck as ce, IconChevronDown as le, IconHome as ue, IconLock as de, IconLogout as fe, IconMail as pe, IconShieldCheck as me, IconShoppingCart as he, IconUser as ge, IconWallet as _e, IconX as ve } from "@tabler/icons-react";
import { z as F } from "zod";
import { useTranslation as I } from "react-i18next";
import { Fragment as L, jsx as R, jsxs as z } from "react/jsx-runtime";
import { useDisclosure as ye, useMediaQuery as be } from "@mantine/hooks";
import { notifications as xe } from "@mantine/notifications";
//#region src/utils/storage/config.ts
var Se = "teletienda-auth", Ce = "teletienda-auth-sync", we = "tt-auth-sync", Te = 2e3, Ee = 720 * 60 * 60, De = ".teletienda.ar", Oe = null;
function ke() {
	return typeof window > "u" ? !1 : window.location.hostname.endsWith(".teletienda.ar");
}
function Ae() {
	if (typeof window > "u") return "localhost";
	let e = window.location.hostname;
	return e.endsWith(".teletienda.ar") ? De : e.endsWith(".teletienda.local") ? ".teletienda.local" : e;
}
function je() {
	let e = ke() || typeof window < "u" && window.location.protocol === "https:";
	return {
		cookieDomain: Ae(),
		secure: e,
		sameSite: "lax",
		maxAge: Ee,
		storageKey: Se
	};
}
function B() {
	return Oe ||= je(), Oe;
}
function Me(e) {
	Oe = {
		...je(),
		...e
	};
}
function Ne() {
	Oe = null;
}
//#endregion
//#region src/utils/storage/cookies.ts
function Pe() {
	let e = /* @__PURE__ */ new Map();
	if (typeof document > "u") return e;
	let t = document.cookie.split(";");
	for (let n of t) {
		let [t, ...r] = n.split("=");
		if (t) {
			let n = t.trim(), i = r.join("=").trim();
			if (n) try {
				e.set(n, decodeURIComponent(i));
			} catch {
				e.set(n, i);
			}
		}
	}
	return e;
}
function Fe(e) {
	return Pe().get(e) ?? null;
}
function Ie(e, t, n) {
	if (typeof document > "u") return;
	let r = B(), i = {
		domain: n?.domain ?? r.cookieDomain,
		path: n?.path ?? "/",
		maxAge: n?.maxAge ?? r.maxAge,
		secure: n?.secure ?? r.secure,
		sameSite: n?.sameSite ?? r.sameSite
	}, a = [
		`${encodeURIComponent(e)}=${encodeURIComponent(t)}`,
		`path=${i.path}`,
		`max-age=${i.maxAge}`,
		`samesite=${i.sameSite}`
	];
	i.domain && i.domain !== "localhost" && a.push(`domain=${i.domain}`), i.secure && a.push("secure"), document.cookie = a.join("; ");
}
function Le(e, t) {
	if (typeof document > "u") return;
	let n = B(), r = t ?? n.cookieDomain, i = [
		`${encodeURIComponent(e)}=`,
		"path=/",
		"max-age=0",
		"expires=Thu, 01 Jan 1970 00:00:00 GMT"
	];
	r && r !== "localhost" && i.push(`domain=${r}`), document.cookie = i.join("; ");
}
function Re() {
	if (typeof document > "u") return !1;
	try {
		let e = "__tt_cookie_test__";
		document.cookie = `${e}=1; path=/`;
		let t = document.cookie.includes(e);
		return document.cookie = `${e}=; path=/; max-age=0`, t;
	} catch {
		return !1;
	}
}
function ze(e, t, n) {
	Ie(e, JSON.stringify(t), n);
}
function Be(e) {
	let t = Fe(e);
	if (!t) return null;
	try {
		return JSON.parse(t);
	} catch {
		return null;
	}
}
//#endregion
//#region src/utils/storage/crossTabSync.ts
var Ve = class {
	channel = null;
	handlers = /* @__PURE__ */ new Set();
	useFallback = !1;
	boundStorageHandler = null;
	constructor() {
		this.init();
	}
	init() {
		if (!(typeof window > "u")) {
			if ("BroadcastChannel" in window) try {
				this.channel = new BroadcastChannel(Ce), this.channel.onmessage = (e) => {
					this.notifyHandlers(e.data);
				};
				return;
			} catch {}
			this.useFallback = !0, this.boundStorageHandler = this.handleStorageEvent.bind(this), window.addEventListener("storage", this.boundStorageHandler);
		}
	}
	handleStorageEvent(e) {
		if (e.key === "teletienda-auth-sync" && e.newValue) try {
			let t = JSON.parse(e.newValue);
			this.notifyHandlers(t);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Sync handler error:", e);
		}
	}
	subscribe(e) {
		return this.handlers.add(e), () => {
			this.handlers.delete(e);
		};
	}
	broadcast(e, t) {
		let n = {
			type: e,
			timestamp: Date.now(),
			data: t
		};
		if (this.channel) this.channel.postMessage(n);
		else if (this.useFallback && typeof localStorage < "u") try {
			localStorage.setItem(`${Se}-sync`, JSON.stringify(n)), localStorage.removeItem(`${Se}-sync`);
		} catch {}
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.channel &&= (this.channel.close(), null), this.boundStorageHandler && typeof window < "u" && (window.removeEventListener("storage", this.boundStorageHandler), this.boundStorageHandler = null), this.handlers.clear();
	}
	isUsingBroadcastChannel() {
		return this.channel !== null;
	}
}, He = null;
function Ue() {
	return He ||= new Ve(), He;
}
function We() {
	He &&= (He.destroy(), null);
}
function Ge(e) {
	return Ue().subscribe(e);
}
function Ke() {
	Ue().broadcastLogin();
}
function qe() {
	Ue().broadcastLogout();
}
function Je() {
	Ue().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/crossSubdomainSync.ts
var Ye = class {
	handlers = /* @__PURE__ */ new Set();
	pollInterval = null;
	lastSeenTimestamp = 0;
	currentOrigin = "";
	constructor() {
		typeof window < "u" && (this.currentOrigin = window.location.origin, this.initializeFromCookie());
	}
	initializeFromCookie() {}
	getPendingEvent() {
		let e = Fe(we);
		if (!e) return null;
		try {
			let t = JSON.parse(e);
			return t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp ? null : t;
		} catch {
			return null;
		}
	}
	startPolling() {
		this.pollInterval || typeof window > "u" || (this.pollInterval = setInterval(() => {
			this.checkForChanges();
		}, Te));
	}
	stopPolling() {
		this.pollInterval &&= (clearInterval(this.pollInterval), null);
	}
	checkForChanges() {
		let e = Fe(we);
		if (e) try {
			let t = JSON.parse(e);
			if (t.origin === this.currentOrigin || t.timestamp <= this.lastSeenTimestamp) return;
			this.lastSeenTimestamp = t.timestamp;
			let n = {
				type: t.type,
				timestamp: t.timestamp
			};
			this.notifyHandlers(n);
		} catch {}
	}
	notifyHandlers(e) {
		for (let t of this.handlers) try {
			t(e);
		} catch (e) {
			console.error("[shared-auth-ui] Cross-subdomain sync handler error:", e);
		}
	}
	subscribe(e) {
		if (this.handlers.add(e), this.handlers.size === 1) {
			this.startPolling();
			let t = this.getPendingEvent();
			t && (this.lastSeenTimestamp = t.timestamp, setTimeout(() => {
				e({
					type: t.type,
					timestamp: t.timestamp
				});
			}, 0));
		}
		return () => {
			this.handlers.delete(e), this.handlers.size === 0 && this.stopPolling();
		};
	}
	broadcast(e) {
		if (typeof window > "u") return;
		let t = {
			type: e,
			timestamp: Date.now(),
			origin: this.currentOrigin
		};
		this.lastSeenTimestamp = t.timestamp, Ie(we, JSON.stringify(t), { maxAge: 300 });
	}
	broadcastLogin() {
		this.broadcast("login");
	}
	broadcastLogout() {
		this.broadcast("logout");
	}
	broadcastTokenRefresh() {
		this.broadcast("token_refresh");
	}
	destroy() {
		this.stopPolling(), this.handlers.clear();
	}
	isPolling() {
		return this.pollInterval !== null;
	}
}, Xe = null;
function Ze() {
	return Xe ||= new Ye(), Xe;
}
function Qe() {
	Xe &&= (Xe.destroy(), null);
}
function $e(e) {
	return Ze().subscribe(e);
}
function et() {
	Ze().broadcastLogin();
}
function tt() {
	Ze().broadcastLogout();
}
function nt() {
	Ze().broadcastTokenRefresh();
}
//#endregion
//#region src/utils/storage/slimCookieStorage.ts
var rt = "tt-auth-slim", it = 3072, at = 4096;
function ot(e) {
	if (!e || typeof e != "object") return !1;
	let t = e;
	return typeof t.token == "string" && typeof t.refreshToken == "string" && typeof t.userGuid == "string" && typeof t.isAuthenticated == "boolean" && typeof t.expiresAt == "number";
}
function st(e) {
	return typeof Blob < "u" ? new Blob([e]).size : new TextEncoder().encode(e).length;
}
function ct() {
	let e = Fe(rt), t = e ? st(e) : 0;
	return {
		currentSize: t,
		maxSize: at,
		warningThreshold: it,
		isOverWarning: t > it,
		isOverLimit: t > at,
		percentUsed: Math.round(t / at * 100)
	};
}
function lt(e) {
	let t = JSON.stringify(e), n = st(t);
	return n > 4096 ? (console.error(`[SlimCookie] Cookie size (${n} bytes) exceeds maximum (${at} bytes). Cookie will NOT be set to prevent silent browser rejection.`), !1) : (n > 3072 && console.warn(`[SlimCookie] Cookie size (${n} bytes) exceeds warning threshold (${it} bytes). Consider reducing stored data.`), Ie(rt, t), !0);
}
function V() {
	let e = Fe(rt);
	if (!e) return null;
	try {
		let t = JSON.parse(e);
		return ot(t) ? t : (console.warn("[SlimCookie] Cookie contains invalid SlimAuthData structure"), null);
	} catch (e) {
		return console.warn("[SlimCookie] Failed to parse cookie JSON:", e), null;
	}
}
function H() {
	Le(rt);
}
//#endregion
//#region src/api/config.ts
var U = { timeout: 3e4 }, ut = null;
function dt(e) {
	U = {
		...U,
		...e
	}, ut = i.create({
		prefixUrl: U.baseUrl,
		timeout: U.timeout,
		hooks: { beforeRequest: [(e) => {
			if (U.getToken) {
				let t = U.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	});
}
function W() {
	return ut ||= i.create({
		timeout: U.timeout,
		hooks: { beforeRequest: [(e) => {
			if (U.getToken) {
				let t = U.getToken();
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}
		}] }
	}), ut;
}
function ft() {
	return { ...U };
}
function pt(e) {
	U.getToken = e;
}
//#endregion
//#region src/utils/transformApiUser.ts
function G(e) {
	return {
		userGuid: e.user_guid,
		email: e.email || e.notification_email || e.notificationEmail,
		name: e.display_name || e.first_name || e.email?.split("@")[0] || "",
		firstName: e.first_name,
		lastName: e.last_name,
		phone: e.phone,
		avatarUrl: e.avatar || e.avatar_url,
		roles: e.roles || [],
		permissions: e.permissions || [],
		merchantGuid: e.merchant_guid,
		merchantGuids: e.merchant_guids,
		preferred_currency: e.preferred_currency,
		languageCode: e.language_code
	};
}
//#endregion
//#region src/utils/storage/authStorage.ts
function mt() {
	let e = {
		localStorage: !1,
		cookies: !1,
		broadcastChannel: !1,
		slimCookieSize: 0,
		slimCookieHealthy: !0
	};
	if (typeof window < "u" && window.localStorage) try {
		let t = "__tt_storage_test__";
		localStorage.setItem(t, "1"), localStorage.removeItem(t), e.localStorage = !0;
	} catch {}
	e.cookies = Re(), typeof window < "u" && "BroadcastChannel" in window && (e.broadcastChannel = !0);
	let t = ct();
	return e.slimCookieSize = t.currentSize, e.slimCookieHealthy = !t.isOverWarning, e;
}
function ht() {
	if (typeof window > "u") return !1;
	try {
		let e = "__tt_private_test__";
		return localStorage.setItem(e, "1"), localStorage.removeItem(e), "storage" in navigator && "estimate" in navigator.storage, !1;
	} catch {
		return !0;
	}
}
function gt(e) {
	let t = B();
	return e === t.storageKey || e.startsWith(t.storageKey) ? e : `${t.storageKey}-${e}`;
}
async function _t(e) {
	try {
		let t = await W().get("api/v1/users/me", { headers: { Authorization: `Bearer ${e}` } }).json();
		return t.success && t.data ? {
			status: "ok",
			user: G(t.data)
		} : (console.warn("[AuthStorage] hydrateFromApi: Invalid response format"), { status: "error" });
	} catch (e) {
		return e instanceof Error && e.message.includes("401") ? { status: "unauthorized" } : (console.warn("[AuthStorage] hydrateFromApi failed:", e), { status: "error" });
	}
}
function vt(e) {
	if (!e || typeof e != "object") return !1;
	let t = e.user;
	return t ? Array.isArray(t.roles) && Array.isArray(t.permissions) && typeof t.email == "string" : !1;
}
function yt() {
	let e = gt(B().storageKey);
	if (typeof window < "u" && window.localStorage) try {
		let t = localStorage.getItem(e);
		if (t && vt(JSON.parse(t)?.state)) return !1;
	} catch {}
	let t = V();
	return t !== null && t.isAuthenticated;
}
var bt = class {
	cookiesAvailable;
	localStorageAvailable;
	constructor() {
		let e = mt();
		this.cookiesAvailable = e.cookies, this.localStorageAvailable = e.localStorage, !this.localStorageAvailable && !this.cookiesAvailable ? console.warn("[shared-auth-ui] No storage available. Auth state will not persist.") : this.cookiesAvailable || console.warn("[shared-auth-ui] Cookies disabled. Cross-subdomain SSO will not work.");
	}
	getItem(e) {
		let t = gt(e), n = null;
		if (this.localStorageAvailable) try {
			n = localStorage.getItem(t);
		} catch {}
		if (n !== null) try {
			if (JSON.parse(n)?.state?.isAuthenticated === !0) return n;
		} catch {}
		if (this.cookiesAvailable) {
			let e = V();
			if (e && e.isAuthenticated) try {
				if ((n ? JSON.parse(n) : null)?.state?.isAuthenticated !== !0) {
					let t = {
						state: {
							user: { userGuid: e.userGuid },
							token: e.token,
							refreshToken: e.refreshToken,
							expiresAt: e.expiresAt,
							isAuthenticated: !0,
							isLoading: !1,
							_needsHydration: !0
						},
						version: 0
					};
					return JSON.stringify(t);
				}
			} catch {
				let t = {
					state: {
						user: { userGuid: e.userGuid },
						token: e.token,
						refreshToken: e.refreshToken,
						expiresAt: e.expiresAt,
						isAuthenticated: !0,
						isLoading: !1,
						_needsHydration: !0
					},
					version: 0
				};
				return JSON.stringify(t);
			}
			else if (e && !e.isAuthenticated && n) try {
				if (JSON.parse(n)?.state?.isAuthenticated === !0) {
					let e = {
						state: {
							user: null,
							token: null,
							refreshToken: null,
							expiresAt: null,
							isAuthenticated: !1,
							isLoading: !1
						},
						version: 0
					};
					if (this.localStorageAvailable) try {
						localStorage.setItem(t, JSON.stringify(e));
					} catch {}
					return JSON.stringify(e);
				}
			} catch {}
		}
		return n === null ? null : n;
	}
	setItem(e, t) {
		let n = gt(e);
		if (this.localStorageAvailable) try {
			localStorage.setItem(n, t);
		} catch (e) {
			if (this.isQuotaExceededError(e)) {
				this.handleQuotaExceeded();
				try {
					localStorage.setItem(n, t);
				} catch {}
			}
		}
		if (this.cookiesAvailable) try {
			let e = JSON.parse(t)?.state, n = e?.user?.userGuid;
			if (e?.token && n) {
				if (!e.expiresAt) return;
				lt({
					token: e.token,
					refreshToken: e.refreshToken || "",
					userGuid: n,
					isAuthenticated: e.isAuthenticated ?? !0,
					expiresAt: e.expiresAt
				});
			} else e?.isAuthenticated || H();
		} catch {}
	}
	removeItem(e) {
		let t = gt(e);
		if (this.localStorageAvailable) try {
			localStorage.removeItem(t);
		} catch {}
		this.cookiesAvailable && (Le(t), H());
	}
	clear() {
		let e = B();
		if (this.localStorageAvailable) try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
		this.cookiesAvailable && (Le(e.storageKey), Le(`${e.storageKey}-sync`), H()), qe();
	}
	isQuotaExceededError(e) {
		return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED");
	}
	handleQuotaExceeded() {
		console.warn("[shared-auth-ui] Storage quota exceeded. Clearing old data.");
		let e = B();
		try {
			let t = [];
			for (let n = 0; n < localStorage.length; n++) {
				let r = localStorage.key(n);
				r && r.startsWith(e.storageKey) && r !== e.storageKey && t.push(r);
			}
			t.forEach((e) => localStorage.removeItem(e));
		} catch {}
	}
	getHealth() {
		let e = ct();
		return {
			localStorage: this.localStorageAvailable,
			cookies: this.cookiesAvailable,
			broadcastChannel: typeof window < "u" && "BroadcastChannel" in window,
			slimCookieSize: e.currentSize,
			slimCookieHealthy: !e.isOverWarning
		};
	}
	notifyLogin() {
		Ke(), et();
	}
	notifyLogout() {
		qe(), tt();
	}
	notifyTokenRefresh() {
		Je(), nt();
	}
}, xt = null;
function K() {
	return xt ||= new bt(), xt;
}
function St() {
	xt = null;
}
function Ct() {
	return K();
}
//#endregion
//#region src/store/authStore.ts
var wt = Se, q = {
	user: null,
	token: null,
	refreshToken: null,
	expiresAt: null,
	isAuthenticated: !1,
	isLoading: !1
}, Tt = null;
function Et(e) {
	Tt = e;
}
function Dt() {
	return Tt || Ct();
}
var Ot = (t, n) => ({
	...q,
	login: (e, n, r, i) => {
		t({
			token: e,
			refreshToken: n,
			expiresAt: Date.now() + r * 1e3,
			user: i,
			isAuthenticated: !0,
			isLoading: !1
		}), K().notifyLogin();
	},
	logout: () => {
		t(q), K().notifyLogout();
	},
	updateToken: (e, n, r) => {
		t({
			token: e,
			expiresAt: Date.now() + n * 1e3,
			...r && { refreshToken: r }
		}), K().notifyTokenRefresh();
	},
	updateUser: (e) => {
		t({ user: e });
	},
	setLoading: (e) => {
		t({ isLoading: e });
	},
	hasRole: (e) => {
		let { user: t } = n();
		return t ? t.roles.includes(e) : !1;
	},
	hasAnyRole: (e) => {
		let { user: t } = n();
		return t ? e.some((e) => t.roles.includes(e)) : !1;
	},
	hasPermission: (t) => {
		let { user: r } = n();
		return r ? e.some((e) => r.roles.includes(e)) ? !0 : r.permissions.includes(t) : !1;
	}
}), kt = {
	name: wt,
	storage: n(() => Dt()),
	partialize: (e) => ({
		user: e.user,
		token: e.token,
		refreshToken: e.refreshToken,
		expiresAt: e.expiresAt,
		isAuthenticated: e.isAuthenticated
	})
}, J = t()(r(Ot, kt)), At = !1;
async function jt(e, t = 3, n = !1) {
	for (let r = 0; r < t; r++) {
		if (await J.persist.rehydrate(), J.getState().isAuthenticated === e) return;
		!n && r < t - 1 && await new Promise((e) => setTimeout(e, 500 * 2 ** r));
	}
	console.warn("[shared-auth-ui] Rehydrate retry exhausted, state may be stale");
}
function Mt() {
	let e = V();
	if (!e?.isAuthenticated || !e?.token) return !1;
	let t = J.getState();
	return t.user?.userGuid && e.userGuid && t.user.userGuid !== e.userGuid ? (console.debug("[shared-auth-ui] UserGuid mismatch - forcing hydration"), !0) : !(t.isAuthenticated && t.user && Array.isArray(t.user.roles) && t.user.roles.length > 0);
}
async function Nt() {
	let e = V();
	if (!e?.token || !e?.isAuthenticated) return;
	let t = J.getState(), n = !t.user?.userGuid || t.user.userGuid === e.userGuid;
	if (!(t.isAuthenticated && t.user?.roles?.length && n)) {
		console.debug(n ? "[shared-auth-ui] Performing initial hydration from slim cookie" : "[shared-auth-ui] Performing initial hydration - userGuid mismatch detected"), J.setState({
			token: e.token,
			refreshToken: e.refreshToken,
			expiresAt: e.expiresAt,
			isAuthenticated: !0,
			isLoading: !0,
			user: null
		});
		try {
			let t = await _t(e.token);
			t.status === "ok" ? (J.setState({
				user: t.user,
				isLoading: !1
			}), console.debug("[shared-auth-ui] Initial hydration successful")) : t.status === "unauthorized" ? (J.setState(q), H(), console.debug("[shared-auth-ui] Initial hydration failed - token rejected (401)")) : (J.setState(q), console.debug("[shared-auth-ui] Initial hydration deferred - transient error, slim cookie preserved"));
		} catch (e) {
			console.warn("[shared-auth-ui] Initial hydration error:", e), J.setState(q);
		}
	}
}
async function Pt() {
	Mt() && await Nt();
}
function Ft() {
	if (At) return console.debug("[shared-auth-ui] Sync already initialized"), () => {};
	At = !0, Mt() && Nt();
	let e = async (e) => {
		let t = J.getState();
		switch (e.type) {
			case "logout":
				t.isAuthenticated && J.setState(q), H(), setTimeout(() => jt(!1), 500);
				break;
			case "login": {
				let e = V();
				if (!e?.token || !e?.isAuthenticated) {
					console.debug("[shared-auth-ui] Cross-subdomain login: no slim cookie, retrying"), setTimeout(() => jt(!0), 500);
					return;
				}
				console.debug("[shared-auth-ui] Cross-subdomain login: validating token before state update"), J.setState({ isLoading: !0 });
				try {
					let t = await _t(e.token);
					t.status === "ok" ? (console.debug("[shared-auth-ui] Cross-subdomain login: token validated, updating state"), J.setState({
						token: e.token,
						refreshToken: e.refreshToken,
						expiresAt: e.expiresAt,
						isAuthenticated: !0,
						isLoading: !1,
						user: t.user
					})) : t.status === "unauthorized" ? (console.warn("[shared-auth-ui] Cross-subdomain login: token rejected (401), clearing state"), J.setState(q), H()) : (console.warn("[shared-auth-ui] Cross-subdomain login: transient error, slim cookie preserved"), J.setState({ isLoading: !1 }));
				} catch (e) {
					console.warn("[shared-auth-ui] Cross-subdomain login: API error", e), J.setState({ isLoading: !1 });
				}
				break;
			}
			case "token_refresh": {
				let e = V();
				e?.token && J.setState({
					token: e.token,
					expiresAt: e.expiresAt
				}), setTimeout(() => J.persist.rehydrate(), 500);
				break;
			}
		}
	}, t = Ge(e), n = $e(e);
	return () => {
		At = !1, t(), n();
	};
}
function It() {
	let { expiresAt: e } = J.getState();
	return e ? Date.now() >= e - 120 * 1e3 : !1;
}
function Lt() {
	let { expiresAt: e } = J.getState();
	return e ? Date.now() >= e : !0;
}
function Y() {
	K().clear();
}
function Rt() {
	return K().getHealth();
}
//#endregion
//#region src/api/authApi.ts
var X = class extends Error {
	code;
	status;
	details;
	constructor(e, t, n, r) {
		super(e), this.name = "AuthApiError", this.code = t, this.status = n, this.details = r;
	}
};
async function zt(e) {
	if (e instanceof a) try {
		let t = await e.response.json();
		throw new X(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
	} catch (t) {
		throw t instanceof X ? t : new X(e.message, "HTTP_ERROR", e.response.status);
	}
	throw e instanceof Error ? new X(e.message, "NETWORK_ERROR", 0) : new X("Unknown error", "UNKNOWN_ERROR", 0);
}
async function Bt(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/login", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Login failed", n.error?.code || "LOGIN_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return zt(e);
	}
}
async function Vt(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/register", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Registration failed", n.error?.code || "REGISTRATION_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return zt(e);
	}
}
async function Ht(e) {
	let t = W();
	try {
		let n = { refreshToken: e }, r = await t.post("api/v1/auth/refresh-token", { json: n }).json();
		if (!r.success || !r.data) throw new X(r.error?.message || "Token refresh failed", r.error?.code || "REFRESH_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return zt(e);
	}
}
async function Ut(e) {
	let t = W();
	try {
		let n = { refreshToken: e };
		await t.post("api/v1/auth/logout", {
			json: n,
			timeout: 5e3
		});
	} catch {}
}
async function Wt(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/auth/request-login-code", { json: { email: e } }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Failed to request login code", n.error?.code || "REQUEST_CODE_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return zt(e);
	}
}
async function Gt(e, t) {
	let n = W();
	try {
		let r = await n.post("api/v1/auth/login-by-code", { json: {
			email: e,
			code: t
		} }).json();
		if (!r.success || !r.data) throw new X(r.error?.message || "Login by code failed", r.error?.code || "LOGIN_BY_CODE_FAILED", 400, r.error?.details);
		return r.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return zt(e);
	}
}
async function Z(e) {
	let t = W();
	try {
		let n = await t.get("api/v1/users/me", {
			headers: { Authorization: `Bearer ${e}` },
			timeout: 1e4
		}).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Failed to fetch user profile", n.error?.code || "PROFILE_FETCH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return zt(e);
	}
}
//#endregion
//#region src/api/oauthApi.ts
async function Kt(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/google/callback", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Google OAuth failed", n.error?.code || "GOOGLE_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return Yt(e, "Google");
	}
}
async function qt(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/facebook/callback", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Facebook OAuth failed", n.error?.code || "FACEBOOK_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return Yt(e, "Facebook");
	}
}
async function Jt(e) {
	let t = W();
	try {
		let n = await t.post("api/v1/oauth/telegram/callback", { json: e }).json();
		if (!n.success || !n.data) throw new X(n.error?.message || "Telegram OAuth failed", n.error?.code || "TELEGRAM_OAUTH_FAILED", 400, n.error?.details);
		return n.data;
	} catch (e) {
		if (e instanceof X) throw e;
		return Yt(e, "Telegram");
	}
}
async function Yt(e, t) {
	let { HTTPError: n } = await import("ky");
	if (e instanceof n) try {
		let n = await e.response.json();
		throw new X(n.error?.message || e.message, n.error?.code || `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status, n.error?.details);
	} catch (n) {
		throw n instanceof X ? n : new X(e.message, `${t.toUpperCase()}_OAUTH_ERROR`, e.response.status);
	}
	throw e instanceof Error ? new X(e.message, "NETWORK_ERROR", 0) : new X("Unknown error", "UNKNOWN_ERROR", 0);
}
//#endregion
//#region src/api/httpClient.ts
var Q = null, Xt = [];
function Zt() {
	Q = null, Xt.length = 0;
}
async function Qt(e) {
	if (Q) return Q;
	let t = J.getState(), n = t.refreshToken;
	if (!n) throw t.logout(), Y(), e?.(), new X("No refresh token", "NO_REFRESH_TOKEN", 401);
	return Q = (async () => {
		try {
			let e = await Ht(n);
			t.updateToken(e.accessToken, e.expiresIn, e.refreshToken);
			let r = e.accessToken;
			return Xt.forEach(({ resolve: e }) => e(r)), Xt.length = 0, r;
		} catch (n) {
			throw Xt.forEach(({ reject: e }) => e(n)), Xt.length = 0, n instanceof X && (n.status === 401 || n.status === 422) && (t.logout(), Y(), e?.()), n;
		} finally {
			Q = null;
		}
	})(), Q;
}
function $t() {
	return new Promise((e, t) => {
		Xt.push({
			resolve: e,
			reject: t
		});
	});
}
function en(e = {}) {
	let { baseUrl: t, timeout: n = 3e4, onSessionExpired: r } = e;
	return i.create({
		prefixUrl: t,
		timeout: n,
		hooks: {
			beforeRequest: [async (e) => {
				if (Q) try {
					let t = await $t();
					e.headers.set("Authorization", `Bearer ${t}`);
					return;
				} catch {}
				let t = J.getState().token;
				t && e.headers.set("Authorization", `Bearer ${t}`);
			}],
			afterResponse: [async (e, t, n) => {
				if (n.status !== 401 || e.url.includes("/auth/refresh") || e.url.includes("/auth/login")) return n;
				try {
					let n = await Qt(r), a = {
						...t,
						headers: {
							...Object.fromEntries(e.headers.entries()),
							Authorization: `Bearer ${n}`
						}
					};
					return i(e.url, a);
				} catch {
					return n;
				}
			}]
		}
	});
}
var tn = null, nn = {};
function rn(e) {
	nn = e, tn = en(e);
}
function an() {
	return tn ||= en(nn), tn;
}
async function on(e, t) {
	let n = an();
	try {
		return await n(e, t).json();
	} catch (e) {
		if (e instanceof a) {
			let t = await e.response.json().catch(() => ({}));
			throw new X(t.error?.message || e.message, t.error?.code || "HTTP_ERROR", e.response.status, t.error?.details);
		}
		throw e;
	}
}
//#endregion
//#region src/hooks/useAuth.ts
function sn() {
	let e = J((e) => e.user), t = J((e) => e.token), n = J((e) => e.refreshToken), r = J((e) => e.isAuthenticated), i = J((e) => e.isLoading), a = J((e) => e.login), o = J((e) => e.logout), s = J((e) => e.updateToken), l = J((e) => e.updateUser), u = J((e) => e.setLoading), d = J((e) => e.hasRole), f = J((e) => e.hasAnyRole), p = J((e) => e.hasPermission);
	return {
		user: e,
		token: t,
		isAuthenticated: r,
		isLoading: i,
		loginWithCredentials: c(async (e) => {
			u(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await Bt(e), o = await Z(t), s = G({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		loginByCode: c(async (e, t) => {
			u(!0);
			try {
				let { accessToken: n, refreshToken: r, expiresIn: i, user: o } = await Gt(e, t), s = await Z(n), c = G({
					...s,
					user_guid: s.user_guid || o.guid,
					email: s.email || o.email
				});
				return a(n, r, i, c), c;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		registerUser: c(async (e) => {
			u(!0);
			try {
				let { accessToken: t, refreshToken: n, expiresIn: r, user: i } = await Vt(e), o = await Z(t), s = G({
					...o,
					user_guid: o.user_guid || i.guid,
					email: o.email || i.email
				});
				return a(t, n, r, s), s;
			} catch (e) {
				throw u(!1), e;
			}
		}, [a, u]),
		refreshToken: c(async () => {
			if (!n) throw o(), Y(), new X("No refresh token available", "NO_REFRESH_TOKEN", 401);
			try {
				let e = await Ht(n);
				s(e.accessToken, e.expiresIn);
			} catch (e) {
				throw o(), Y(), e;
			}
		}, [
			n,
			o,
			s
		]),
		logout: c(async () => {
			n && Ut(n), o(), Y();
		}, [n, o]),
		fetchProfile: c(async (e) => {
			if (!t) throw new X("Not authenticated", "NOT_AUTHENTICATED", 401);
			let n = e?.silent ?? !1;
			n || u(!0);
			try {
				let e = G(await Z(t));
				return l(e), n || u(!1), e;
			} catch (e) {
				throw n || u(!1), e;
			}
		}, [
			t,
			u,
			l
		]),
		hasRole: d,
		hasAnyRole: f,
		hasPermission: p
	};
}
//#endregion
//#region src/hooks/useHasHydrated.ts
function cn() {
	let [e, t] = p(() => J.persist?.hasHydrated?.() ?? !1);
	return u(() => {
		if (e) return;
		let n = J.persist?.onFinishHydration?.(() => {
			t(!0);
		});
		return J.persist?.hasHydrated?.() && t(!0), () => {
			n?.();
		};
	}, [e]), e;
}
//#endregion
//#region src/hooks/useAuthGuard.ts
function ln(e = {}) {
	let { requiredRoles: t = [], requiredPermissions: n = [], requireAllRoles: r = !1 } = e, i = cn(), a = J((e) => e.user), o = J((e) => e.isAuthenticated), s = J((e) => e.hasRole), c = J((e) => e.hasPermission), l = !i;
	return {
		...d(() => {
			if (!o || !a) return {
				isAllowed: !1,
				isAuthenticated: !1,
				missingRoles: t,
				missingPermissions: n,
				denyReason: "not_authenticated"
			};
			let e = [], i = !0;
			t.length > 0 && (r ? (e = t.filter((e) => !s(e)), i = e.length === 0) : t.some((e) => s(e)) || (e = t, i = !1));
			let l = n.filter((e) => !c(e)), u = l.length === 0;
			return i ? u ? {
				isAllowed: !0,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: [],
				denyReason: "none"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: [],
				missingPermissions: l,
				denyReason: "missing_permissions"
			} : {
				isAllowed: !1,
				isAuthenticated: !0,
				missingRoles: e,
				missingPermissions: l,
				denyReason: "missing_roles"
			};
		}, [
			o,
			a,
			t,
			n,
			r,
			s,
			c
		]),
		isLoading: l,
		user: a
	};
}
//#endregion
//#region src/hooks/useTokenRefresh.ts
var un = 300 * 1e3, dn = 3, fn = 1e3, $ = null;
function pn() {
	return $;
}
function mn() {
	$ = null;
}
function hn(e = {}) {
	let { refreshThreshold: t = un, maxRetries: n = dn, retryBaseDelay: r = fn, onRefreshError: i, onSessionExpired: a } = e, [o, s] = p(!1), [l, d] = p(null), [m, h] = p(0), [g, _] = p(null), v = f(null), y = f(null), b = f(!0), x = J((e) => e.refreshToken), S = J((e) => e.expiresAt), C = J((e) => e.isAuthenticated), w = J((e) => e.updateToken), T = J((e) => e.logout), E = c(() => {
		v.current &&= (clearTimeout(v.current), null);
	}, []), D = c(() => {
		y.current &&= (clearInterval(y.current), null);
	}, []), O = c(async (e = 0) => {
		if ($) return $;
		if (!x) throw new X("No refresh token available", "NO_REFRESH_TOKEN", 401);
		return $ = (async () => {
			try {
				b.current && (s(!0), h(e));
				let t = await Ht(x);
				b.current && (w(t.accessToken, t.expiresIn, t.refreshToken), d(/* @__PURE__ */ new Date()), h(0));
			} catch (t) {
				let o = t instanceof X ? t : new X(t instanceof Error ? t.message : "Unknown error", "REFRESH_ERROR", 0);
				if (o.status === 401 || o.status === 422) throw b.current && (T(), Y()), a?.(), o;
				if (o.code === "NETWORK_ERROR" && e < n) {
					let t = r * 2 ** e;
					return await new Promise((e) => setTimeout(e, t)), $ = null, O(e + 1);
				}
				throw i?.(o), o;
			} finally {
				$ = null, b.current && s(!1);
			}
		})(), $;
	}, [
		x,
		w,
		T,
		n,
		r,
		i,
		a
	]), k = c(() => {
		if (E(), !S || !C) return;
		let e = Date.now(), n = S - t - e;
		n <= 0 ? O().catch(() => {}) : v.current = setTimeout(() => {
			document.visibilityState === "visible" && O().catch(() => {});
		}, n);
	}, [
		S,
		C,
		t,
		E,
		O
	]), A = c(() => {
		document.visibilityState === "visible" ? S && C && (S - Date.now() <= t ? O().catch(() => {}) : k()) : E();
	}, [
		S,
		C,
		t,
		O,
		k,
		E
	]), j = c(async () => O(0), [O]);
	return u(() => {
		if (D(), !S || !C) {
			_(null);
			return;
		}
		let e = () => {
			let e = S - Date.now();
			_(e > 0 ? e : 0);
		};
		return e(), y.current = setInterval(e, 1e3), () => {
			D();
		};
	}, [
		S,
		C,
		D
	]), u(() => {
		k();
	}, [k]), u(() => (document.addEventListener("visibilitychange", A), () => {
		document.removeEventListener("visibilitychange", A);
	}), [A]), u(() => (b.current = !0, () => {
		b.current = !1, E(), D();
	}), [E, D]), {
		isRefreshing: o,
		lastRefresh: l,
		refresh: j,
		timeUntilExpiry: g,
		retryCount: m
	};
}
//#endregion
//#region ../node_modules/@react-oauth/google/dist/index.esm.js
function gn(e = {}) {
	let { nonce: t, locale: n, onScriptLoadSuccess: r, onScriptLoadError: i } = e, [a, o] = p(!1), s = f(r);
	s.current = r;
	let c = f(i);
	return c.current = i, u(() => {
		let e = document.createElement("script");
		return e.src = "https://accounts.google.com/gsi/client", n && (e.src += `?hl=${n}`), e.async = !0, e.defer = !0, e.nonce = t, e.onload = () => {
			var e;
			o(!0), (e = s.current) == null || e.call(s);
		}, e.onerror = () => {
			var e;
			o(!1), (e = c.current) == null || e.call(c);
		}, document.body.appendChild(e), () => {
			document.body.removeChild(e);
		};
	}, [t]), a;
}
var _n = s(null);
function vn({ clientId: e, nonce: t, locale: n, onScriptLoadSuccess: r, onScriptLoadError: i, children: a }) {
	let s = gn({
		nonce: t,
		onScriptLoadSuccess: r,
		onScriptLoadError: i,
		locale: n
	}), c = d(() => ({
		locale: n,
		clientId: e,
		scriptLoadedSuccessfully: s
	}), [e, s]);
	return o.createElement(_n.Provider, { value: c }, a);
}
function yn() {
	let e = l(_n);
	if (!e) throw Error("Google OAuth components must be used within GoogleOAuthProvider");
	return e;
}
function bn({ flow: e = "implicit", scope: t = "", onSuccess: n, onError: r, onNonOAuthError: i, overrideScope: a, state: o, ...s }) {
	let { clientId: l, scriptLoadedSuccessfully: d } = yn(), p = f(), m = f(n);
	m.current = n;
	let h = f(r);
	h.current = r;
	let g = f(i);
	g.current = i, u(() => {
		if (!d) return;
		let n = e === "implicit" ? "initTokenClient" : "initCodeClient";
		p.current = ((window == null ? void 0 : window.google)?.accounts)?.oauth2[n]({
			client_id: l,
			scope: a ? t : `openid profile email ${t}`,
			callback: (e) => {
				var t;
				if (e.error) return h.current?.call(h, e);
				(t = m.current) == null || t.call(m, e);
			},
			error_callback: (e) => {
				var t;
				(t = g.current) == null || t.call(g, e);
			},
			state: o,
			...s
		});
	}, [
		l,
		d,
		e,
		t,
		o
	]);
	let _ = c((e) => p.current?.requestAccessToken(e), []), v = c(() => p.current?.requestCode(), []);
	return e === "implicit" ? _ : v;
}
//#endregion
//#region src/hooks/useGoogleAuth.ts
function xn(e = {}) {
	let { onSuccess: t, onError: n, redirectUri: r } = e, i = J((e) => e.login), a = J((e) => e.setLoading), [o, s] = p(!1), [l, u] = p(null), d = bn({
		onSuccess: c(async (e) => {
			s(!0), a(!0), u(null);
			try {
				let n = await Kt({
					code: e.access_token,
					redirectUri: r || window.location.origin
				}), a = await Z(n.accessToken), o = G({
					...a,
					user_guid: a.user_guid || n.user.guid,
					email: a.email || n.user.email || void 0
				});
				i(n.accessToken, n.refreshToken, n.expiresIn, o), t?.(n, o);
			} catch (e) {
				let t = e instanceof Error ? e : /* @__PURE__ */ Error("Google authentication failed");
				u(t), a(!1), n?.(t);
			} finally {
				s(!1);
			}
		}, [
			i,
			a,
			t,
			n,
			r
		]),
		onError: c((e) => {
			let t = e.error_description || e.error || "Google login failed", r = Error(t);
			u(r), a(!1), n?.(r);
		}, [a, n]),
		onNonOAuthError: c((e) => {
			let t = "Google login failed";
			e.type === "popup_closed" ? t = "Login popup was closed" : e.type === "popup_failed_to_open" && (t = "Failed to open login popup. Please allow popups for this site.");
			let r = Error(t);
			u(r), n?.(r);
		}, [n]),
		flow: "implicit",
		scope: "email profile openid"
	});
	return {
		login: c(() => {
			u(null), d();
		}, [d]),
		isLoading: o,
		error: l
	};
}
//#endregion
//#region src/hooks/useFacebookAuth.ts
function Sn(e) {
	let { appId: t, onSuccess: n, onError: r } = e, i = J((e) => e.login), a = J((e) => e.setLoading), [o, s] = p(!1), [l, d] = p(!1), [m, h] = p(null), g = f(!1);
	u(() => {
		if (window.FB) {
			d(!0);
			return;
		}
		if (g.current) return;
		if (document.getElementById("facebook-jssdk")) {
			g.current = !0;
			return;
		}
		g.current = !0, window.fbAsyncInit = () => {
			window.FB?.init({
				appId: t,
				version: "v18.0",
				cookie: !0,
				xfbml: !1
			}), d(!0);
		};
		let e = document.createElement("script");
		e.id = "facebook-jssdk", e.src = "https://connect.facebook.net/en_US/sdk.js", e.async = !0, e.defer = !0, document.body.appendChild(e);
	}, [t]);
	let _ = c(async (e) => {
		if (e.status !== "connected" || !e.authResponse) {
			let t = /* @__PURE__ */ Error(e.status === "not_authorized" ? "Facebook login not authorized. Please grant permissions." : "Facebook login was cancelled or failed");
			h(t), s(!1), a(!1), r?.(t);
			return;
		}
		try {
			let t = await qt({ accessToken: e.authResponse.accessToken }), r = await Z(t.accessToken), a = G({
				...r,
				user_guid: r.user_guid || t.user.guid,
				email: r.email || t.user.email || void 0
			});
			i(t.accessToken, t.refreshToken, t.expiresIn, a), n?.(t, a);
		} catch (e) {
			let t = e instanceof Error ? e : /* @__PURE__ */ Error("Facebook authentication failed");
			h(t), a(!1), r?.(t);
		} finally {
			s(!1);
		}
	}, [
		i,
		a,
		n,
		r
	]);
	return {
		login: c(() => {
			if (!l || !window.FB) {
				let e = /* @__PURE__ */ Error("Facebook SDK not ready. Please try again.");
				h(e), r?.(e);
				return;
			}
			s(!0), a(!0), h(null), window.FB.getLoginStatus((e) => {
				e.status === "connected" && e.authResponse ? _(e) : window.FB.login((e) => {
					_(e);
				}, { scope: "email,public_profile" });
			});
		}, [
			l,
			_,
			a,
			r
		]),
		isLoading: o,
		isReady: l,
		error: m
	};
}
//#endregion
//#region src/hooks/useTelegramAuth.ts
function Cn(e) {
	let { botUsername: t, onSuccess: n, onError: r, size: i = "large", requestAccess: a = !1, showUserPic: o = !1 } = e, s = J((e) => e.login), l = J((e) => e.setLoading), [d, m] = p(!1), [h, g] = p(!1), [_, v] = p(null), y = f(null), b = f(`telegramAuth_${Date.now()}`), x = f(!1), S = f(void 0);
	u(() => {
		S.current = async (e) => {
			m(!0), l(!0), v(null);
			try {
				let t = await Jt(e), r = await Z(t.accessToken), i = G({
					...r,
					user_guid: r.user_guid || t.user.guid,
					email: r.email || t.user.email || void 0
				});
				s(t.accessToken, t.refreshToken, t.expiresIn, i), n?.(t, i);
			} catch (e) {
				let t = e instanceof Error ? e : /* @__PURE__ */ Error("Telegram authentication failed");
				v(t), l(!1), r?.(t);
			} finally {
				m(!1);
			}
		};
	}, [
		s,
		l,
		n,
		r
	]);
	let C = c((e) => {
		S.current?.(e);
	}, []);
	return u(() => {
		if (!y.current || x.current) return;
		let e = y.current.querySelector("script[src*=\"telegram-widget\"]"), n = y.current.querySelector("iframe");
		if (e || n) {
			x.current = !0;
			return;
		}
		x.current = !0;
		let s = b.current;
		window[s] = C, window.onTelegramAuth = C;
		let c = document.createElement("script");
		return c.src = "https://telegram.org/js/telegram-widget.js?22", c.async = !0, c.setAttribute("data-telegram-login", t), c.setAttribute("data-size", i), c.setAttribute("data-onauth", `${s}(user)`), c.setAttribute("data-userpic", o ? "true" : "false"), a && c.setAttribute("data-request-access", "write"), c.onload = () => {
			g(!0);
		}, c.onerror = () => {
			let e = /* @__PURE__ */ Error("Failed to load Telegram Login Widget");
			v(e), r?.(e);
		}, y.current.appendChild(c), () => {
			delete window[s], window.onTelegramAuth === C && delete window.onTelegramAuth, x.current = !1;
		};
	}, [
		t,
		i,
		a,
		o,
		C,
		r
	]), {
		containerRef: y,
		isLoading: d,
		isReady: h,
		error: _
	};
}
//#endregion
//#region ../node_modules/zod/v4/core/core.js
var wn;
function Tn(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var En = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
};
(wn = globalThis).__zod_globalConfig ?? (wn.__zod_globalConfig = {});
var Dn = globalThis.__zod_globalConfig;
function On(e) {
	return e && Object.assign(Dn, e), Dn;
}
//#endregion
//#region ../node_modules/zod/v4/core/util.js
function kn(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
var An = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
-Number.MAX_VALUE, Number.MAX_VALUE;
function jn(e) {
	return typeof e == "string" ? e : e?.message;
}
function Mn(e, t, n) {
	let r = e.message ? e.message : jn(e.inst?._zod.def?.error?.(e)) ?? jn(t?.error?.(e)) ?? jn(n.customError?.(e)) ?? jn(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
//#endregion
//#region ../node_modules/zod/v4/core/errors.js
var Nn = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, kn, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, Pn = Tn("$ZodError", Nn), Fn = /* @__PURE__*/ ((e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new En();
	if (o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => Mn(e, a, On())));
		throw An(t, i?.callee), t;
	}
	return o.value;
})(Tn("$ZodError", Nn, { Parent: Error }));
//#endregion
//#region ../node_modules/mantine-form-zod-resolver/dist/esm/index.mjs
function In(e, t) {
	return (n) => {
		try {
			return Fn(e, n), {};
		} catch (e) {
			if (e instanceof Pn) {
				let n = {};
				return t?.errorPriority === "first" && e.issues.reverse(), e.issues.forEach((e) => {
					n[e.path.join(".")] = e.message;
				}), n;
			}
			throw e;
		}
	};
}
//#endregion
//#region src/components/GoogleLoginButton/GoogleLoginButton.tsx
function Ln({ onSuccess: e, onError: t, label: n, iconOnly: r = !1, ...i }) {
	let { t: a } = I("auth"), { login: o, isLoading: s } = xn({
		onSuccess: e,
		onError: t
	}), c = n ?? a("oauth.google.button", "Sign in with Google");
	return r ? /* @__PURE__ */ R(v, {
		onClick: o,
		loading: s,
		variant: "default",
		...i,
		"aria-label": c,
		"data-testid": "google-login-button",
		children: /* @__PURE__ */ R(se, { size: 18 })
	}) : /* @__PURE__ */ R(v, {
		leftSection: /* @__PURE__ */ R(se, { size: 18 }),
		onClick: o,
		loading: s,
		variant: "default",
		...i,
		"aria-label": c,
		"data-testid": "google-login-button",
		children: c
	});
}
//#endregion
//#region src/components/FacebookLoginButton/FacebookLoginButton.tsx
function Rn({ appId: e, onSuccess: t, onError: n, label: r, iconOnly: i = !1, ...a }) {
	let { t: o } = I("auth"), { login: s, isLoading: c, isReady: l } = Sn({
		appId: e,
		onSuccess: t,
		onError: n
	}), u = r ?? o("oauth.facebook.button", "Sign in with Facebook");
	return i ? /* @__PURE__ */ R(v, {
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: /* @__PURE__ */ R(oe, { size: 18 })
	}) : /* @__PURE__ */ R(v, {
		leftSection: /* @__PURE__ */ R(oe, { size: 18 }),
		onClick: s,
		loading: c,
		disabled: !l,
		variant: "default",
		...a,
		"aria-label": u,
		"data-testid": "facebook-login-button",
		children: u
	});
}
//#endregion
//#region src/components/TelegramLoginButton/TelegramLoginButton.tsx
function zn({ botUsername: e, onSuccess: t, onError: n, size: r = "large", requestAccess: i = !1, showUserPic: a = !1, showLoader: o = !0, ...s }) {
	let { t: c } = I("auth"), { containerRef: l, isLoading: d, error: f } = Cn({
		botUsername: e,
		onSuccess: t,
		onError: n,
		size: r,
		requestAccess: i,
		showUserPic: a
	}), [h, g] = p(!1), [v, b] = p(!1);
	u(() => {
		if (!l.current) return;
		let e = new MutationObserver((t) => {
			for (let n of t) n.type === "childList" && l.current?.querySelector("iframe") && (g(!0), e.disconnect());
		});
		return e.observe(l.current, {
			childList: !0,
			subtree: !0
		}), () => e.disconnect();
	}, [l]), u(() => {
		if (h || v) return;
		let e = setTimeout(() => {
			b(!0);
		}, 1e4);
		return () => clearTimeout(e);
	}, [h, v]);
	let x = r === "large" ? 40 : r === "medium" ? 32 : 24;
	return /* @__PURE__ */ z(_, {
		...s,
		"data-testid": "telegram-login-button",
		style: {
			position: "relative",
			minHeight: x,
			...s.style
		},
		children: [
			/* @__PURE__ */ R("div", {
				ref: l,
				style: {
					display: "flex",
					justifyContent: "center"
				}
			}),
			o && !h && !v && /* @__PURE__ */ z(y, {
				py: "sm",
				children: [/* @__PURE__ */ R(C, {
					size: "sm",
					mr: "xs"
				}), /* @__PURE__ */ R(j, {
					size: "sm",
					c: "dimmed",
					children: c("oauth.telegram.loading", "Loading Telegram...")
				})]
			}),
			v && !h && /* @__PURE__ */ R(m, {
				color: "yellow",
				variant: "light",
				py: "xs",
				children: /* @__PURE__ */ R(j, {
					size: "xs",
					c: "dimmed",
					ta: "center",
					children: c("oauth.telegram.load_timeout", "Telegram widget could not load. Try refreshing the page.")
				})
			}),
			d && /* @__PURE__ */ R(_, {
				style: {
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					backgroundColor: "rgba(255, 255, 255, 0.8)"
				},
				children: /* @__PURE__ */ R(C, { size: "sm" })
			}),
			f && /* @__PURE__ */ R(j, {
				size: "xs",
				c: "red",
				mt: "xs",
				children: f.message
			})
		]
	});
}
//#endregion
//#region src/components/SocialLoginButtons/SocialLoginButtons.tsx
function Bn({ google: e = !0, facebook: t = !0, telegram: n = !0, googleClientId: r, facebookAppId: i, telegramBotUsername: a, onSuccess: o, onError: s, showDivider: c = !0, dividerText: l, layout: u = "vertical", ...d }) {
	let { t: f } = I("auth");
	e && !r && console.warn("SocialLoginButtons: googleClientId is required when google=true"), t && !i && console.warn("SocialLoginButtons: facebookAppId is required when facebook=true"), n && !a && console.warn("SocialLoginButtons: telegramBotUsername is required when telegram=true");
	let p = (e) => (t, n) => {
		o?.(t, n, e);
	}, m = (e) => (t) => {
		s?.(t, e);
	};
	if ([
		e && r,
		t && i,
		n && a
	].filter(Boolean).length === 0) return null;
	let h = /* @__PURE__ */ z(L, { children: [
		e && r && /* @__PURE__ */ R(vn, {
			clientId: r,
			children: /* @__PURE__ */ R(Ln, {
				onSuccess: p("google"),
				onError: m("google"),
				fullWidth: u === "vertical"
			})
		}),
		t && i && /* @__PURE__ */ R(Rn, {
			appId: i,
			onSuccess: p("facebook"),
			onError: m("facebook"),
			fullWidth: u === "vertical"
		}),
		n && a && /* @__PURE__ */ R(zn, {
			botUsername: a,
			onSuccess: p("telegram"),
			onError: m("telegram")
		})
	] });
	return /* @__PURE__ */ z(A, {
		gap: "sm",
		...d,
		"data-testid": "social-login-buttons",
		children: [c && /* @__PURE__ */ R(x, {
			label: /* @__PURE__ */ R(j, {
				size: "sm",
				c: "dimmed",
				children: l || f("oauth.divider", "or")
			}),
			labelPosition: "center"
		}), u === "vertical" ? /* @__PURE__ */ R(A, {
			gap: "xs",
			children: h
		}) : /* @__PURE__ */ R(S, {
			gap: "xs",
			justify: "center",
			children: h
		})]
	});
}
//#endregion
//#region src/components/LoginForm/LoginForm.tsx
var Vn = F.object({
	email: F.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	password: F.string().min(1, "login.errors.password_required")
}), Hn = F.object({
	email: F.string().min(1, "login.errors.email_required").email("login.errors.email_invalid"),
	code: F.string().min(6, "login.errors.code_invalid").max(6, "login.errors.code_invalid")
});
function Un({ onSuccess: e, onError: t, disabled: n = !1, showSocialLogin: r = !0, googleClientId: i, facebookAppId: a, telegramBotUsername: o, onSocialSuccess: s, onSocialError: l, showCodeLogin: d = !0, defaultMethod: f = "password" }) {
	let { t: g } = I("auth"), { loginWithCredentials: _, loginByCode: y, isLoading: b } = sn(), [S, C] = p(null), [w, T] = p(f), [E, O] = p(!1), [te, ne] = p(!1), M = ie({
		initialValues: {
			email: "",
			password: ""
		},
		validate: In(Vn)
	}), N = ie({
		initialValues: {
			email: "",
			code: ""
		},
		validate: In(Hn)
	});
	u(() => {
		w === "code" ? N.setFieldValue("email", M.values.email) : M.setFieldValue("email", N.values.email), C(null);
	}, [w]);
	let re = c(async (n) => {
		C(null);
		try {
			let t = await _({
				email: n.email,
				password: n.password
			});
			e?.(t);
		} catch (e) {
			let n = Wn(e, g);
			C(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		_,
		e,
		t,
		g
	]), ae = c(async () => {
		if (!N.validateField("email").hasError) {
			C(null), ne(!0);
			try {
				await Wt(N.values.email), O(!0);
			} catch (e) {
				C(Gn(e, g));
			} finally {
				ne(!1);
			}
		}
	}, [N, g]), oe = c(async (n) => {
		C(null);
		try {
			let t = await y(n.email, n.code);
			e?.(t);
		} catch (e) {
			let n = Gn(e, g);
			C(n), t?.(e instanceof Error ? e : Error(n));
		}
	}, [
		y,
		e,
		t,
		g
	]), se = c(() => {
		O(!1), N.setFieldValue("code", ""), C(null);
	}, [N]), ce = c((t, n, r) => {
		e?.(n), s?.(t, r);
	}, [e, s]), le = b || n;
	return /* @__PURE__ */ z(A, {
		gap: "md",
		children: [
			r && /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(Bn, {
				googleClientId: i,
				facebookAppId: a,
				telegramBotUsername: o,
				onSuccess: ce,
				onError: l,
				showDivider: !1
			}), /* @__PURE__ */ R(x, {
				label: /* @__PURE__ */ R(j, {
					size: "sm",
					c: "dimmed",
					children: g("login.or_with_email")
				}),
				labelPosition: "center"
			})] }),
			S && /* @__PURE__ */ R(m, {
				icon: /* @__PURE__ */ R(P, { size: 16 }),
				color: "red",
				variant: "light",
				title: g("login.error_title"),
				"aria-live": "polite",
				"data-testid": "login-error",
				children: S
			}),
			d && /* @__PURE__ */ R(k, {
				value: w,
				onChange: (e) => T(e),
				data: [{
					label: g("login.method_password"),
					value: "password"
				}, {
					label: g("login.method_code"),
					value: "code"
				}],
				fullWidth: !0,
				"data-testid": "login-method-toggle"
			}),
			w === "password" && /* @__PURE__ */ R("form", {
				onSubmit: M.onSubmit(re),
				noValidate: !0,
				children: /* @__PURE__ */ z(A, {
					gap: "md",
					children: [
						/* @__PURE__ */ R(ee, {
							label: g("login.email_label"),
							placeholder: g("login.email_placeholder"),
							leftSection: /* @__PURE__ */ R(pe, { size: 16 }),
							autoComplete: "email",
							type: "email",
							inputMode: "email",
							"data-autofocus": !0,
							"data-testid": "login-email",
							"aria-label": g("login.email_label"),
							"aria-required": "true",
							"aria-invalid": !!M.errors.email,
							disabled: le,
							...M.getInputProps("email"),
							error: M.errors.email ? g(M.errors.email) : void 0
						}),
						/* @__PURE__ */ R(D, {
							label: g("login.password_label"),
							placeholder: g("login.password_placeholder"),
							leftSection: /* @__PURE__ */ R(de, { size: 16 }),
							autoComplete: "current-password",
							"data-testid": "login-password",
							"aria-label": g("login.password_label"),
							"aria-required": "true",
							"aria-invalid": !!M.errors.password,
							disabled: le,
							...M.getInputProps("password"),
							error: M.errors.password ? g(M.errors.password) : void 0
						}),
						/* @__PURE__ */ R(v, {
							type: "submit",
							fullWidth: !0,
							loading: b,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: g("login.submit")
						})
					]
				})
			}),
			w === "code" && /* @__PURE__ */ R("form", {
				onSubmit: N.onSubmit(oe),
				noValidate: !0,
				children: /* @__PURE__ */ z(A, {
					gap: "md",
					children: [/* @__PURE__ */ R(ee, {
						label: g("login.email_label"),
						placeholder: g("login.email_placeholder"),
						leftSection: /* @__PURE__ */ R(pe, { size: 16 }),
						autoComplete: "email",
						type: "email",
						inputMode: "email",
						"data-autofocus": !0,
						"data-testid": "login-email",
						"aria-label": g("login.email_label"),
						"aria-required": "true",
						"aria-invalid": !!N.errors.email,
						disabled: le || E,
						...N.getInputProps("email"),
						error: N.errors.email ? g(N.errors.email) : void 0
					}), E ? /* @__PURE__ */ z(L, { children: [
						/* @__PURE__ */ R(j, {
							size: "sm",
							c: "teal",
							"data-testid": "login-code-sent-msg",
							children: g("login.code_sent")
						}),
						/* @__PURE__ */ R(ee, {
							label: g("login.code"),
							placeholder: "000000",
							leftSection: /* @__PURE__ */ R(me, { size: 16 }),
							autoComplete: "one-time-code",
							inputMode: "numeric",
							maxLength: 6,
							"data-testid": "login-code",
							"aria-label": g("login.code"),
							"aria-required": "true",
							"aria-invalid": !!N.errors.code,
							disabled: le,
							...N.getInputProps("code"),
							error: N.errors.code ? g(N.errors.code) : void 0
						}),
						/* @__PURE__ */ R(v, {
							type: "submit",
							fullWidth: !0,
							loading: b,
							disabled: n,
							"data-testid": "login-submit",
							mt: "xs",
							children: g("login.verify_and_sign_in")
						}),
						/* @__PURE__ */ R(h, {
							component: "button",
							type: "button",
							size: "sm",
							ta: "center",
							onClick: se,
							"data-testid": "login-resend-code",
							children: g("login.resend_code")
						})
					] }) : /* @__PURE__ */ R(v, {
						fullWidth: !0,
						variant: "light",
						loading: te,
						disabled: n,
						onClick: ae,
						"data-testid": "login-send-code",
						mt: "xs",
						children: g("login.send_code")
					})]
				})
			})
		]
	});
}
function Wn(e, t) {
	if (e instanceof X) switch (e.code) {
		case "INVALID_CREDENTIALS": return t("login.errors.invalid_credentials");
		case "ACCOUNT_LOCKED": return t("login.errors.account_locked");
		case "ACCOUNT_DISABLED": return t("login.errors.account_disabled");
		case "EMAIL_NOT_VERIFIED": return t("login.errors.email_not_verified");
		default: return e.message || t("login.errors.generic");
	}
	return e instanceof Error && e.message || t("login.errors.generic");
}
function Gn(e, t) {
	if (e instanceof X) switch (e.code) {
		case "CODE_EXPIRED": return t("login.errors.code_expired");
		case "RATE_LIMITED": return t("login.errors.code_rate_limited");
		case "INVALID_CODE": {
			let n = e.details?.remaining;
			return n === void 0 ? t("login.errors.code_invalid_value", { remaining: "?" }) : t("login.errors.code_invalid_value", { remaining: n });
		}
		default: return e.message || t("login.errors.code_send_failed");
	}
	return e instanceof Error && e.message || t("login.errors.code_send_failed");
}
//#endregion
//#region src/components/LoginModal/LoginModal.tsx
function Kn({ opened: e, onClose: t, onSuccess: n, onError: r, title: i, subtitle: a, closeOnSuccess: o = !0, size: s = "sm", centered: l = !0, showSocialLogin: u = !1, showCodeLogin: d, defaultMethod: f, googleClientId: p, facebookAppId: m, telegramBotUsername: h }) {
	let { t: g } = I("auth"), _ = c((e) => {
		n?.(e), o && t();
	}, [
		n,
		t,
		o
	]);
	return /* @__PURE__ */ R(T, {
		opened: e,
		onClose: t,
		title: i || g("login.modal_title"),
		size: s,
		centered: l,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !0,
		"aria-labelledby": "login-modal-title",
		"data-testid": "login-modal",
		children: /* @__PURE__ */ z(A, {
			gap: "md",
			children: [a && /* @__PURE__ */ R(j, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: a
			}), /* @__PURE__ */ R(Un, {
				onSuccess: _,
				onError: r,
				showSocialLogin: u,
				showCodeLogin: d,
				defaultMethod: f,
				googleClientId: p,
				facebookAppId: m,
				telegramBotUsername: h
			})]
		})
	});
}
//#endregion
//#region src/components/LoginPage/LoginPage.tsx
function qn({ onSuccess: e, onError: t, redirectOnSuccess: n, logo: r, backgroundImage: i, title: a, subtitle: o, maxWidth: s = 420, showSocialLogin: l = !1, showCodeLogin: u, defaultMethod: d, googleClientId: f, facebookAppId: p, telegramBotUsername: m }) {
	let { t: h } = I("auth"), g = re(), v = N("light") === "dark", b = c((t) => {
		e?.(t), n && typeof window < "u" && (window.location.href = n);
	}, [e, n]);
	return /* @__PURE__ */ R(y, {
		mih: "100vh",
		style: {
			...i ? {
				backgroundImage: `url(${i})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat"
			} : {},
			backgroundColor: i ? void 0 : v ? g.colors.dark[8] : g.colors.gray[0]
		},
		"data-testid": "login-page",
		children: /* @__PURE__ */ R(_, {
			w: {
				base: "100%",
				sm: s
			},
			px: "md",
			py: "xl",
			children: /* @__PURE__ */ z(A, {
				gap: "lg",
				align: "center",
				children: [
					r && /* @__PURE__ */ R(_, {
						mb: "md",
						"data-testid": "login-page-logo",
						children: r
					}),
					/* @__PURE__ */ R(E, {
						p: "xl",
						shadow: "md",
						radius: "md",
						withBorder: !0,
						w: "100%",
						style: i ? {
							backgroundColor: "rgba(255, 255, 255, 0.95)",
							backdropFilter: "blur(10px)"
						} : void 0,
						children: /* @__PURE__ */ z(A, {
							gap: "md",
							children: [
								/* @__PURE__ */ R(ne, {
									order: 2,
									ta: "center",
									"data-testid": "login-page-title",
									children: a || h("login.page_title")
								}),
								(o || !a) && /* @__PURE__ */ R(j, {
									size: "sm",
									c: "dimmed",
									ta: "center",
									children: o || h("login.page_subtitle")
								}),
								/* @__PURE__ */ R(Un, {
									onSuccess: b,
									onError: t,
									showSocialLogin: l,
									showCodeLogin: u,
									defaultMethod: d,
									googleClientId: f,
									facebookAppId: p,
									telegramBotUsername: m
								})
							]
						})
					}),
					/* @__PURE__ */ R(j, {
						size: "xs",
						c: "dimmed",
						ta: "center",
						children: h("login.help_text")
					})
				]
			})
		})
	});
}
//#endregion
//#region src/components/RegisterForm/PasswordStrengthIndicator.tsx
function Jn(e) {
	return [
		{
			key: "length",
			label: "password.requirements.length",
			met: e.length >= 8
		},
		{
			key: "uppercase",
			label: "password.requirements.uppercase",
			met: /[A-Z]/.test(e)
		},
		{
			key: "lowercase",
			label: "password.requirements.lowercase",
			met: /[a-z]/.test(e)
		},
		{
			key: "number",
			label: "password.requirements.number",
			met: /[0-9]/.test(e)
		}
	];
}
function Yn(e) {
	if (!e) return 0;
	let t = Jn(e), n = t.filter((e) => e.met).length / t.length * 80, r = /[!@#$%^&*(),.?":{}|<>]/.test(e) ? 10 : 0, i = Math.min(10, Math.max(0, e.length - 8));
	return Math.min(100, n + r + i);
}
function Xn(e) {
	return e < 30 ? "red" : e < 60 ? "yellow" : e < 80 ? "lime" : "green";
}
function Zn(e) {
	return e < 30 ? "password.strength.weak" : e < 60 ? "password.strength.fair" : e < 80 ? "password.strength.good" : "password.strength.strong";
}
function Qn({ met: e, label: t }) {
	let { t: n } = I("auth");
	return /* @__PURE__ */ z(S, {
		gap: "xs",
		wrap: "nowrap",
		children: [/* @__PURE__ */ R(te, {
			size: "xs",
			radius: "xl",
			color: e ? "green" : "red",
			variant: "light",
			children: R(e ? ce : ve, { size: 10 })
		}), /* @__PURE__ */ R(j, {
			size: "xs",
			c: e ? "dimmed" : void 0,
			style: { textDecoration: e ? "line-through" : void 0 },
			children: n(t)
		})]
	});
}
function $n({ password: e, showRequirements: t = !0, compact: n = !1 }) {
	let { t: r } = I("auth"), i = d(() => Yn(e), [e]), a = d(() => Jn(e), [e]), o = Xn(i), s = Zn(i);
	return e ? n ? /* @__PURE__ */ R(O, {
		value: i,
		color: o,
		size: "xs",
		"aria-label": r("password.strength.label"),
		"aria-valuenow": i,
		"aria-valuemin": 0,
		"aria-valuemax": 100
	}) : /* @__PURE__ */ z(A, {
		gap: "xs",
		"data-testid": "password-strength-indicator",
		children: [
			/* @__PURE__ */ z(S, {
				justify: "space-between",
				gap: "xs",
				children: [/* @__PURE__ */ R(j, {
					size: "xs",
					c: "dimmed",
					children: r("password.strength.label")
				}), /* @__PURE__ */ R(j, {
					size: "xs",
					c: o,
					fw: 500,
					children: r(s)
				})]
			}),
			/* @__PURE__ */ R(O, {
				value: i,
				color: o,
				size: "sm",
				"aria-label": r("password.strength.label"),
				"aria-valuenow": i,
				"aria-valuemin": 0,
				"aria-valuemax": 100,
				"data-testid": "password-strength-progress"
			}),
			t && /* @__PURE__ */ R(_, {
				mt: "xs",
				children: /* @__PURE__ */ R(A, {
					gap: 4,
					children: a.map((e) => /* @__PURE__ */ R(Qn, {
						met: e.met,
						label: e.label
					}, e.key))
				})
			})
		]
	}) : null;
}
//#endregion
//#region src/components/RegisterForm/RegisterForm.tsx
var er = F.object({
	name: F.string().min(1, "register.errors.name_required").max(100, "register.errors.name_too_long"),
	email: F.string().min(1, "register.errors.email_required").email("register.errors.email_invalid"),
	password: F.string().min(8, "register.errors.password_min_length").refine((e) => /[A-Z]/.test(e), "register.errors.password_uppercase").refine((e) => /[a-z]/.test(e), "register.errors.password_lowercase").refine((e) => /[0-9]/.test(e), "register.errors.password_number"),
	confirmPassword: F.string().min(1, "register.errors.confirm_password_required"),
	acceptTerms: F.boolean().refine((e) => e === !0, "register.errors.terms_required")
}).refine((e) => e.password === e.confirmPassword, {
	message: "register.errors.passwords_mismatch",
	path: ["confirmPassword"]
});
function tr({ onSuccess: e, onError: t, showLogin: n = !1, onLoginClick: r, termsUrl: i = "/terms", privacyUrl: a = "/privacy", submitLabel: o, disabled: s = !1, showPasswordStrength: l = !0, showSocialLogin: u = !1, googleClientId: d, facebookAppId: f, telegramBotUsername: g, onSocialSuccess: _, onSocialError: y }) {
	let { t: C } = I("auth"), [w, T] = p(!1), [E, O] = p(null), k = ie({
		initialValues: {
			name: "",
			email: "",
			password: "",
			confirmPassword: "",
			acceptTerms: !1
		},
		validate: In(er)
	}), te = c((e) => Jn(e).every((e) => e.met), []), ne = c(async (n) => {
		O(null), T(!0);
		try {
			await Vt({
				email: n.email,
				password: n.password,
				firstName: n.name.split(" ")[0],
				lastName: n.name.split(" ").slice(1).join(" ") || void 0
			}), e?.();
		} catch (e) {
			let n;
			if (e instanceof X) switch (e.code) {
				case "EMAIL_EXISTS":
				case "USER_EXISTS":
					n = C("register.errors.email_exists");
					break;
				case "VALIDATION_ERROR":
					n = C("register.errors.validation_error");
					break;
				case "RATE_LIMITED":
					n = C("register.errors.rate_limited");
					break;
				default: n = e.message || C("register.errors.generic");
			}
			else n = e instanceof Error && e.message || C("register.errors.generic");
			O(n), t?.(e instanceof Error ? e : Error(n));
		} finally {
			T(!1);
		}
	}, [
		e,
		t,
		C
	]), M = w || s, N = k.values.password && !te(k.values.password), re = c((t, n, r) => {
		e?.(n), _?.(t, r);
	}, [e, _]);
	return /* @__PURE__ */ R("form", {
		onSubmit: k.onSubmit(ne),
		noValidate: !0,
		children: /* @__PURE__ */ z(A, {
			gap: "md",
			children: [
				u && /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(Bn, {
					googleClientId: d,
					facebookAppId: f,
					telegramBotUsername: g,
					onSuccess: re,
					onError: y,
					showDivider: !1
				}), /* @__PURE__ */ R(x, {
					label: /* @__PURE__ */ R(j, {
						size: "sm",
						c: "dimmed",
						children: C("register.or_email", "or with email")
					}),
					labelPosition: "center"
				})] }),
				E && /* @__PURE__ */ R(m, {
					icon: /* @__PURE__ */ R(P, { size: 16 }),
					color: "red",
					variant: "light",
					title: C("register.error_title"),
					"aria-live": "polite",
					"data-testid": "register-error",
					children: E
				}),
				/* @__PURE__ */ R(ee, {
					label: C("register.name_label"),
					placeholder: C("register.name_placeholder"),
					leftSection: /* @__PURE__ */ R(ge, { size: 16 }),
					autoComplete: "name",
					"data-autofocus": !0,
					"data-testid": "register-name",
					"aria-label": C("register.name_label"),
					"aria-required": "true",
					"aria-invalid": !!k.errors.name,
					disabled: M,
					...k.getInputProps("name"),
					error: k.errors.name ? C(k.errors.name) : void 0
				}),
				/* @__PURE__ */ R(ee, {
					label: C("register.email_label"),
					placeholder: C("register.email_placeholder"),
					leftSection: /* @__PURE__ */ R(pe, { size: 16 }),
					autoComplete: "email",
					type: "email",
					inputMode: "email",
					"data-testid": "register-email",
					"aria-label": C("register.email_label"),
					"aria-required": "true",
					"aria-invalid": !!k.errors.email,
					disabled: M,
					...k.getInputProps("email"),
					error: k.errors.email ? C(k.errors.email) : void 0
				}),
				/* @__PURE__ */ z(A, {
					gap: "xs",
					children: [/* @__PURE__ */ R(D, {
						label: C("register.password_label"),
						placeholder: C("register.password_placeholder"),
						leftSection: /* @__PURE__ */ R(de, { size: 16 }),
						autoComplete: "new-password",
						"data-testid": "register-password",
						"aria-label": C("register.password_label"),
						"aria-required": "true",
						"aria-invalid": !!k.errors.password,
						"aria-describedby": "password-requirements",
						disabled: M,
						...k.getInputProps("password"),
						error: k.errors.password ? C(k.errors.password) : void 0
					}), l && /* @__PURE__ */ R("div", {
						id: "password-requirements",
						children: /* @__PURE__ */ R($n, {
							password: k.values.password,
							showRequirements: !0
						})
					})]
				}),
				/* @__PURE__ */ R(D, {
					label: C("register.confirm_password_label"),
					placeholder: C("register.confirm_password_placeholder"),
					leftSection: /* @__PURE__ */ R(de, { size: 16 }),
					autoComplete: "new-password",
					"data-testid": "register-confirm-password",
					"aria-label": C("register.confirm_password_label"),
					"aria-required": "true",
					"aria-invalid": !!k.errors.confirmPassword,
					disabled: M,
					...k.getInputProps("confirmPassword"),
					error: k.errors.confirmPassword ? C(k.errors.confirmPassword) : void 0
				}),
				/* @__PURE__ */ R(b, {
					label: /* @__PURE__ */ z(L, { children: [
						C("register.terms_prefix"),
						" ",
						/* @__PURE__ */ R(h, {
							href: i,
							target: "_blank",
							size: "sm",
							children: C("register.terms_link")
						}),
						" ",
						C("register.terms_and"),
						" ",
						/* @__PURE__ */ R(h, {
							href: a,
							target: "_blank",
							size: "sm",
							children: C("register.privacy_link")
						})
					] }),
					"data-testid": "register-terms",
					"aria-required": "true",
					"aria-invalid": !!k.errors.acceptTerms,
					disabled: M,
					...k.getInputProps("acceptTerms", { type: "checkbox" }),
					error: k.errors.acceptTerms ? C(k.errors.acceptTerms) : void 0
				}),
				/* @__PURE__ */ R(v, {
					type: "submit",
					fullWidth: !0,
					loading: w,
					disabled: s || !!N,
					"data-testid": "register-submit",
					mt: "xs",
					children: o || C("register.submit")
				}),
				n && /* @__PURE__ */ R(S, {
					justify: "center",
					mt: "xs",
					children: /* @__PURE__ */ R(h, {
						component: "button",
						type: "button",
						size: "sm",
						onClick: r,
						"data-testid": "register-login-link",
						children: C("register.have_account")
					})
				})
			]
		})
	});
}
//#endregion
//#region src/components/RegisterModal/VerificationSuccess.tsx
function nr({ email: e, onResendClick: t, onLoginClick: n, title: r, message: i }) {
	let { t: a } = I("auth"), [o, s] = p(!1), [l, u] = p(!1), [d, f] = p(null), g = c(async () => {
		if (t) {
			s(!0), u(!1), f(null);
			try {
				await t(), u(!0);
			} catch (e) {
				f(e instanceof Error ? e.message : a("register.verification.resend_error"));
			} finally {
				s(!1);
			}
		}
	}, [t, a]);
	return /* @__PURE__ */ z(A, {
		gap: "lg",
		align: "center",
		"data-testid": "verification-success",
		children: [
			/* @__PURE__ */ R(y, { children: /* @__PURE__ */ R(te, {
				size: 80,
				radius: 80,
				variant: "light",
				color: "green",
				"aria-hidden": "true",
				children: /* @__PURE__ */ R(pe, { size: 40 })
			}) }),
			/* @__PURE__ */ z(A, {
				gap: "xs",
				align: "center",
				children: [/* @__PURE__ */ R(j, {
					size: "xl",
					fw: 600,
					ta: "center",
					children: r || a("register.verification.title")
				}), /* @__PURE__ */ R(j, {
					size: "sm",
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: i || a("register.verification.message", { email: e })
				})]
			}),
			l && /* @__PURE__ */ R(m, {
				icon: /* @__PURE__ */ R(ce, { size: 16 }),
				color: "green",
				variant: "light",
				w: "100%",
				"data-testid": "resend-success",
				children: a("register.verification.resend_success")
			}),
			d && /* @__PURE__ */ R(m, {
				icon: /* @__PURE__ */ R(P, { size: 16 }),
				color: "red",
				variant: "light",
				w: "100%",
				"data-testid": "resend-error",
				children: d
			}),
			/* @__PURE__ */ z(A, {
				gap: "md",
				w: "100%",
				children: [t && /* @__PURE__ */ R(v, {
					variant: "light",
					fullWidth: !0,
					loading: o,
					disabled: l,
					onClick: g,
					"data-testid": "resend-verification",
					children: a(l ? "register.verification.resend_sent" : "register.verification.resend_button")
				}), n && /* @__PURE__ */ R(y, { children: /* @__PURE__ */ R(h, {
					component: "button",
					type: "button",
					size: "sm",
					onClick: n,
					"data-testid": "back-to-login",
					children: a("register.verification.back_to_login")
				}) })]
			})
		]
	});
}
//#endregion
//#region src/components/RegisterModal/RegisterModal.tsx
function rr({ opened: e, onClose: t, onSuccess: n, onError: r, showLogin: i = !1, onLoginClick: a, termsUrl: o, privacyUrl: s, onResendVerification: l, title: u, subtitle: d, size: f = "sm", centered: m = !0, showSocialLogin: h = !1, googleClientId: g, facebookAppId: _, telegramBotUsername: v }) {
	let { t: y } = I("auth"), [b, x] = p(!1), [S, C] = p(""), w = c(() => {
		n?.(), x(!0);
	}, [n]), E = c(() => {
		a && a(), t();
	}, [a, t]), D = c(async () => {
		l && S && await l(S);
	}, [l, S]), O = c(() => {
		x(!1), C(""), t();
	}, [t]), k = c(() => {
		w();
	}, [w]);
	return /* @__PURE__ */ R(T, {
		opened: e,
		onClose: O,
		title: b ? y("register.verification.title") : u || y("register.modal_title"),
		size: f,
		centered: m,
		trapFocus: !0,
		closeOnEscape: !0,
		closeOnClickOutside: !b,
		"aria-labelledby": "register-modal-title",
		"data-testid": "register-modal",
		children: /* @__PURE__ */ z(A, {
			gap: "md",
			children: [!b && d && /* @__PURE__ */ R(j, {
				size: "sm",
				c: "dimmed",
				ta: "center",
				children: d
			}), b ? /* @__PURE__ */ R(nr, {
				email: S,
				onResendClick: l ? D : void 0,
				onLoginClick: E
			}) : /* @__PURE__ */ R(ir, {
				onSuccess: k,
				onError: r,
				onEmailCapture: C,
				showLogin: i,
				onLoginClick: E,
				termsUrl: o,
				privacyUrl: s,
				showSocialLogin: h,
				googleClientId: g,
				facebookAppId: _,
				telegramBotUsername: v
			})]
		})
	});
}
function ir({ onSuccess: e, onError: t, onEmailCapture: n, ...r }) {
	return /* @__PURE__ */ R("div", {
		onSubmitCapture: c((e) => {
			let t = e.currentTarget.querySelector("form");
			if (t) {
				let e = t.querySelector("[data-testid=\"register-email\"]");
				e && n(e.value);
			}
		}, [n]),
		children: /* @__PURE__ */ R(tr, {
			onSuccess: e,
			onError: t,
			...r
		})
	});
}
//#endregion
//#region src/components/AuthGuard/UnauthorizedFallback.tsx
function ar({ title: e, message: t, showBackButton: n = !0, showHomeButton: r = !0, homeUrl: i = "/", onBack: a, onHome: o }) {
	let { t: s } = I("auth");
	return /* @__PURE__ */ z(A, {
		align: "center",
		justify: "center",
		gap: "xl",
		mih: 400,
		p: "xl",
		children: [
			/* @__PURE__ */ R(te, {
				size: 80,
				radius: "xl",
				variant: "light",
				color: "red",
				children: /* @__PURE__ */ R(de, { size: 40 })
			}),
			/* @__PURE__ */ z(A, {
				align: "center",
				gap: "xs",
				children: [/* @__PURE__ */ R(ne, {
					order: 2,
					ta: "center",
					children: e || s("guard.unauthorized_title", "Access Denied")
				}), /* @__PURE__ */ R(j, {
					c: "dimmed",
					ta: "center",
					maw: 400,
					children: t || s("guard.unauthorized_message", "You don't have permission to access this page.")
				})]
			}),
			/* @__PURE__ */ z(S, {
				gap: "md",
				children: [n && /* @__PURE__ */ R(v, {
					variant: "default",
					leftSection: /* @__PURE__ */ R(ae, { size: 16 }),
					onClick: () => {
						a ? a() : window.history.back();
					},
					children: s("guard.go_back", "Go Back")
				}), r && /* @__PURE__ */ R(v, {
					variant: "filled",
					leftSection: /* @__PURE__ */ R(ue, { size: 16 }),
					onClick: () => {
						o ? o() : window.location.href = i;
					},
					children: s("guard.go_home", "Go Home")
				})]
			})
		]
	});
}
//#endregion
//#region src/components/AuthGuard/LoadingFallback.tsx
function or({ message: e, minHeight: t = "100vh", size: n = "lg" }) {
	let { t: r } = I("auth");
	return /* @__PURE__ */ R(y, {
		mih: t,
		children: /* @__PURE__ */ z(A, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ R(C, { size: n }), /* @__PURE__ */ R(j, {
				c: "dimmed",
				size: "sm",
				children: e || r("guard.loading", "Checking authentication...")
			})]
		})
	});
}
//#endregion
//#region src/components/AuthGuard/redirectUtils.ts
var sr = "returnTo", cr = 2e3;
function lr(e) {
	if (!e || typeof e != "string" || e.length > cr) return !1;
	try {
		if (e.startsWith("/")) return !e.startsWith("//");
		let t = new URL(e, window.location.origin), n = new URL(window.location.origin);
		if (t.origin !== n.origin) {
			let e = t.hostname;
			if (![".teletienda.ar", ".teletienda.local"].some((t) => e.endsWith(t) || e === t.slice(1))) return !1;
		}
		return !0;
	} catch {
		return !1;
	}
}
function ur(e, t) {
	if (!t || !lr(t)) return e;
	try {
		let n = new URL(e, window.location.origin);
		return n.searchParams.set(sr, t), n.origin === window.location.origin ? n.pathname + n.search : n.toString();
	} catch {
		return e;
	}
}
function dr() {
	try {
		let e = new URLSearchParams(window.location.search).get(sr);
		return e && lr(e) ? e : null;
	} catch {
		return null;
	}
}
function fr() {
	return window.location.pathname + window.location.search;
}
function pr(e) {
	let t = lr(e) ? e : "/";
	window.location.href = t;
}
function mr(e) {
	try {
		let t = new URL(e, window.location.origin), n = window.location;
		return t.pathname === n.pathname && t.search === n.search;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/components/AuthGuard/AuthGuard.tsx
function hr({ children: e, redirectTo: t, preserveReturnUrl: n = !0, fallback: r, loadingComponent: i, onDenied: a, navigate: o, requiredRoles: s, requiredPermissions: c, requireAllRoles: l }) {
	let { isAllowed: d, isLoading: p, isAuthenticated: m, denyReason: h, missingRoles: g, missingPermissions: _ } = ln({
		requiredRoles: s,
		requiredPermissions: c,
		requireAllRoles: l
	}), v = f(!1);
	return u(() => {
		if (!p) {
			if (d) {
				v.current = !1;
				return;
			}
			if (h !== "none" && a && a(h), h === "not_authenticated" && t) {
				if (v.current) return;
				let e = ur(t, n ? fr() : void 0);
				if (mr(e)) {
					console.warn("[AuthGuard] Redirect loop detected, skipping redirect");
					return;
				}
				v.current = !0, o ? o(e, { replace: !0 }) : pr(e);
			}
		}
	}, [
		p,
		d,
		m,
		h,
		t,
		n,
		a,
		o
	]), p ? i || /* @__PURE__ */ R(or, {}) : d ? /* @__PURE__ */ R(L, { children: e }) : m && h !== "not_authenticated" ? r || /* @__PURE__ */ R(ar, {
		missingRoles: g,
		missingPermissions: _
	}) : t ? i || /* @__PURE__ */ R(or, {}) : r || /* @__PURE__ */ R(ar, {});
}
//#endregion
//#region src/components/AuthGuard/ProtectedRoute.tsx
function gr({ children: e, element: t, ...n }) {
	let r = t || e;
	return /* @__PURE__ */ R(hr, {
		...n,
		children: r
	});
}
//#endregion
//#region src/components/UserMenu/UserAvatar.tsx
function _r({ src: e, name: t, size: n = "md", radius: r = "xl", className: i }) {
	return /* @__PURE__ */ R(g, {
		src: e,
		name: t,
		alt: t,
		size: n,
		radius: r,
		color: "initials",
		className: i
	});
}
var vr = {
	userButton: "_userButton_1mcpb_5",
	userName: "_userName_1mcpb_28",
	chevron: "_chevron_1mcpb_32"
};
//#endregion
//#region src/components/UserMenu/UserMenu.tsx
function yr({ showProfile: e = !0, showOrders: t = !1, showFinances: n = !1, profileHref: r = "/profile", ordersHref: i = "/orders", financesHref: a = "/finances", additionalItems: o = [], onLogout: s, confirmLogout: l = !1, logoutRedirect: u, avatarSrc: d, hideUserName: f = !1, children: m }) {
	let { t: h } = I("auth"), { user: g, logout: _, isLoading: y } = sn(), [b, x] = p(!1), [C, { open: E, close: D }] = ye(!1), [O, k] = p(!1), ee = be("(max-width: 768px)"), te = f || ee, ne = c(() => {
		l ? E() : N();
	}, [l, E]), N = c(async () => {
		k(!0);
		try {
			let e = u || "/";
			window.location.href = e, await _(), xe.show({
				title: h("userMenu.logout_success_title"),
				message: h("userMenu.logout_success_message"),
				color: "blue",
				autoClose: 3e3
			}), s?.();
		} finally {
			k(!1), D();
		}
	}, [
		_,
		s,
		u,
		D,
		h
	]), re = c(() => {
		N();
	}, [N]);
	if (!g) return null;
	let ie = g.name || "", P = [];
	e && P.push({
		label: h("userMenu.profile"),
		icon: ge,
		href: r
	}), t && P.push({
		label: h("userMenu.orders"),
		icon: he,
		href: i
	}), n && P.push({
		label: h("userMenu.finances"),
		icon: _e,
		href: a
	});
	let ae = [...P, ...o], oe = (e, t) => {
		let n = [];
		e.dividerBefore && n.push(/* @__PURE__ */ R(w.Divider, {}, `divider-before-${t}`));
		let r = e.icon, i = /* @__PURE__ */ R(w.Item, {
			leftSection: r ? /* @__PURE__ */ R(r, {
				size: 16,
				stroke: 1.5
			}) : void 0,
			onClick: e.onClick,
			component: e.href ? "a" : void 0,
			href: e.href,
			children: e.label
		}, `item-${t}`);
		return n.push(i), e.dividerAfter && n.push(/* @__PURE__ */ R(w.Divider, {}, `divider-after-${t}`)), n;
	};
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ z(w, {
		width: 220,
		position: "bottom-end",
		transitionProps: { transition: "pop-top-right" },
		opened: b,
		onChange: x,
		withinPortal: !0,
		children: [/* @__PURE__ */ R(w.Target, { children: /* @__PURE__ */ R(M, {
			className: vr.userButton,
			"data-opened": b || void 0,
			"aria-label": h("userMenu.menuLabel"),
			children: /* @__PURE__ */ z(S, {
				gap: "xs",
				wrap: "nowrap",
				children: [/* @__PURE__ */ R(_r, {
					src: d,
					name: ie,
					size: "sm"
				}), !te && /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(j, {
					size: "sm",
					fw: 500,
					className: vr.userName,
					lineClamp: 1,
					children: ie
				}), /* @__PURE__ */ R(le, {
					size: 14,
					stroke: 1.5,
					className: vr.chevron,
					"data-opened": b || void 0
				})] })]
			})
		}) }), /* @__PURE__ */ z(w.Dropdown, { children: [
			ae.map((e, t) => oe(e, t)),
			ae.length > 0 && /* @__PURE__ */ R(w.Divider, {}),
			/* @__PURE__ */ R(w.Item, {
				color: "red",
				leftSection: /* @__PURE__ */ R(fe, {
					size: 16,
					stroke: 1.5
				}),
				onClick: ne,
				disabled: y || O,
				children: h("userMenu.logout")
			}),
			m
		] })]
	}), /* @__PURE__ */ R(T, {
		opened: C,
		onClose: D,
		title: h("userMenu.logoutConfirmTitle"),
		centered: !0,
		size: "sm",
		children: /* @__PURE__ */ z(A, {
			gap: "md",
			children: [/* @__PURE__ */ R(j, {
				size: "sm",
				children: h("userMenu.logoutConfirmMessage")
			}), /* @__PURE__ */ z(S, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ R(v, {
					variant: "default",
					onClick: D,
					disabled: O,
					children: h("userMenu.cancel")
				}), /* @__PURE__ */ R(v, {
					color: "red",
					onClick: re,
					loading: O,
					children: h("userMenu.logout")
				})]
			})]
		})
	})] });
}
//#endregion
//#region src/components/AuthProvider/AuthProvider.tsx
var br = s(null);
function xr() {
	let e = l(br);
	if (!e) throw Error("useAuthContext must be used within AuthProvider");
	return e;
}
function Sr({ children: e, apiBaseUrl: t, apiTimeout: n = 3e4, enableCrossTabSync: r = !0, refreshThreshold: i, maxRetries: a, retryBaseDelay: o, onRefreshError: s, onSessionExpired: c }) {
	let l = hn({
		refreshThreshold: i,
		maxRetries: a,
		retryBaseDelay: o,
		onRefreshError: s,
		onSessionExpired: c
	});
	d(() => {
		dt({
			baseUrl: t,
			timeout: n,
			getToken: () => J.getState().token
		}), pt(() => J.getState().token);
	}, [t, n]), u(() => {
		let e;
		return r && (e = Ft()), () => {
			e?.();
		};
	}, [r]);
	let f = {
		...l,
		isInitialized: !0
	};
	return /* @__PURE__ */ R(br.Provider, {
		value: f,
		children: e
	});
}
//#endregion
//#region src/components/AuthCallbackPage/AuthCallbackPage.tsx
function Cr({ onSuccess: e, onError: t, defaultReturnUrl: n = "/" }) {
	let { t: r } = I("auth"), [i, a] = p(null), [o, s] = p(!0), c = J((e) => e.login);
	u(() => {
		l();
	}, []);
	async function l() {
		try {
			let t = new URLSearchParams(window.location.search), i = t.get("code"), a = t.get("state"), o = t.get("error"), s = t.get("error_description");
			if (o) throw Error(r("oauth.errors.provider_denied", { error: s || o }));
			let l = {};
			if (a) try {
				l = JSON.parse(atob(a));
			} catch {
				console.warn("[AuthCallbackPage] Failed to parse OAuth state");
			}
			let u = l.provider || wr(t), d = l.returnUrl || n;
			if (!u) throw Error(r("oauth.errors.unknown_provider"));
			if (!i) throw Error(r("oauth.errors.missing_code"));
			let f = `${window.location.origin}/auth/callback`, p;
			switch (u) {
				case "google":
					p = await Kt({
						code: i,
						redirectUri: f
					});
					break;
				case "facebook": throw Error(r("oauth.errors.facebook_no_redirect"));
				case "telegram": throw Error(r("oauth.errors.telegram_no_redirect"));
				default: throw Error(r("oauth.errors.unknown_provider"));
			}
			let m = await Z(p.accessToken), h = G({
				...m,
				user_guid: m.user_guid || p.user.guid,
				email: m.email || p.user.email || void 0
			});
			c(p.accessToken, p.refreshToken, p.expiresIn, h), e?.(d);
		} catch (e) {
			let n = e instanceof Error ? e.message : r("oauth.errors.generic");
			a(n), t?.(e instanceof Error ? e : Error(n));
		} finally {
			s(!1);
		}
	}
	return o ? /* @__PURE__ */ R(y, {
		h: "100vh",
		children: /* @__PURE__ */ z(A, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ R(C, { size: "lg" }), /* @__PURE__ */ R(j, {
				c: "dimmed",
				children: r("oauth.processing")
			})]
		})
	}) : i ? /* @__PURE__ */ R(y, {
		h: "100vh",
		children: /* @__PURE__ */ R(m, {
			icon: /* @__PURE__ */ R(P, { size: 16 }),
			title: r("oauth.error_title"),
			color: "red",
			variant: "light",
			maw: 400,
			children: i
		})
	}) : null;
}
function wr(e) {
	let t = e.get("scope");
	if (t?.includes("google") || t?.includes("openid")) return "google";
	let n = e.get("state");
	if (n) try {
		if (JSON.parse(atob(n)).provider === "facebook") return "facebook";
	} catch {}
	return e.has("authuser") ? "google" : null;
}
//#endregion
//#region src/utils/token.ts
function Tr(e) {
	try {
		let t = e.split(".");
		if (t.length !== 3) return null;
		let n = t[1], r = atob(n.replace(/-/g, "+").replace(/_/g, "/"));
		return JSON.parse(r);
	} catch {
		return null;
	}
}
function Er(e) {
	let t = Tr(e);
	return t?.exp ? /* @__PURE__ */ new Date(t.exp * 1e3) : null;
}
function Dr(e, t = 0) {
	let n = Er(e);
	if (!n) return !0;
	let r = t * 1e3;
	return Date.now() >= n.getTime() - r;
}
function Or(e) {
	return Tr(e)?.sub ?? null;
}
function kr(e) {
	let t = Er(e);
	if (!t) return 0;
	let n = t.getTime() - Date.now();
	return Math.max(0, Math.floor(n / 1e3));
}
var Ar = {
	login: {
		modal_title: "Iniciar sesión",
		page_title: "Iniciar sesión",
		page_subtitle: "Ingresa con tu cuenta",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Tu contraseña",
		submit: "Iniciar sesión",
		remember_me: "Recordarme",
		forgot_password: "¿Olvidaste tu contraseña?",
		no_account: "¿No tienes cuenta? Regístrate",
		error_title: "Error de autenticación",
		help_text: "¿Problemas para ingresar? Contacta al administrador.",
		success_title: "¡Bienvenido!",
		success_message: "Has iniciado sesión correctamente",
		or_with_email: "o con email",
		method_password: "Contraseña",
		method_code: "Código por email",
		send_code: "Enviar código de acceso",
		code: "Código de verificación",
		verify_and_sign_in: "Verificar e ingresar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado a tu email",
		errors: {
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			password_required: "La contraseña es requerida",
			invalid_credentials: "Correo o contraseña incorrectos",
			account_locked: "Tu cuenta está bloqueada. Contacta al administrador.",
			account_disabled: "Tu cuenta está deshabilitada",
			email_not_verified: "Por favor verifica tu correo electrónico",
			generic: "Ocurrió un error. Intenta de nuevo.",
			code_invalid: "El código debe tener 6 dígitos",
			code_send_failed: "Error al enviar el código. Intenta de nuevo.",
			code_expired: "Código expirado. Solicita uno nuevo.",
			code_rate_limited: "Demasiados intentos. Espera 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} intentos restantes."
		}
	},
	register: {
		modal_title: "Crear cuenta",
		page_title: "Registrarse",
		page_subtitle: "Crea tu cuenta",
		name_label: "Nombre completo",
		name_placeholder: "Juan Pérez",
		email_label: "Correo electrónico",
		email_placeholder: "tu@email.com",
		password_label: "Contraseña",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar contraseña",
		confirm_password_placeholder: "Repite tu contraseña",
		terms_prefix: "Acepto los",
		terms_link: "Términos y Condiciones",
		terms_and: "y la",
		privacy_link: "Política de Privacidad",
		submit: "Crear cuenta",
		have_account: "¿Ya tienes cuenta? Inicia sesión",
		or_email: "o con email",
		error_title: "Error de registro",
		errors: {
			name_required: "El nombre es requerido",
			name_too_long: "El nombre es muy largo (máximo 100 caracteres)",
			email_required: "El correo electrónico es requerido",
			email_invalid: "Correo electrónico inválido",
			email_exists: "Ya existe una cuenta con este correo",
			password_min_length: "La contraseña debe tener al menos 8 caracteres",
			password_uppercase: "La contraseña debe contener al menos una mayúscula",
			password_lowercase: "La contraseña debe contener al menos una minúscula",
			password_number: "La contraseña debe contener al menos un número",
			confirm_password_required: "Confirma tu contraseña",
			passwords_mismatch: "Las contraseñas no coinciden",
			terms_required: "Debes aceptar los términos y condiciones",
			validation_error: "Error de validación. Revisa los campos.",
			rate_limited: "Demasiados intentos. Intenta más tarde.",
			generic: "Ocurrió un error. Intenta de nuevo."
		},
		verification: {
			title: "Verifica tu correo",
			message: "Hemos enviado un enlace de verificación a {{email}}. Por favor revisa tu bandeja de entrada.",
			resend_button: "Reenviar correo de verificación",
			resend_sent: "Correo enviado",
			resend_success: "Hemos reenviado el correo de verificación.",
			resend_error: "Error al reenviar. Intenta de nuevo.",
			back_to_login: "Volver a iniciar sesión"
		}
	},
	password: {
		strength: {
			label: "Fortaleza de contraseña",
			weak: "Débil",
			fair: "Regular",
			good: "Buena",
			strong: "Fuerte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Al menos una letra mayúscula",
			lowercase: "Al menos una letra minúscula",
			number: "Al menos un número"
		}
	},
	guard: {
		loading: "Verificando autenticación...",
		unauthorized_title: "Acceso Denegado",
		unauthorized_message: "No tienes permiso para acceder a esta página.",
		go_back: "Volver",
		go_home: "Ir al Inicio"
	},
	userMenu: {
		menuLabel: "Menú de usuario",
		profile: "Mi Perfil",
		orders: "Mis Pedidos",
		finances: "Mis Finanzas",
		logout: "Cerrar sesión",
		logoutConfirmTitle: "Cerrar sesión",
		logoutConfirmMessage: "¿Estás seguro de que quieres cerrar sesión?",
		cancel: "Cancelar",
		logout_success_title: "Sesión cerrada",
		logout_success_message: "Has cerrado sesión correctamente"
	},
	portal: {
		title: "Iniciar sesión en TeleTienda",
		register_title: "Crear cuenta TeleTienda",
		continue_to: "para continuar a {{domain}}",
		redirecting: "Redirigiendo a {{domain}}...",
		code_error: "Error al completar la autenticación. Por favor, inténtalo de nuevo."
	},
	oauth: {
		divider: "o continuar con",
		processing: "Iniciando sesión...",
		error_title: "Error de autenticación",
		google: {
			button: "Iniciar sesión con Google",
			signup_button: "Registrarse con Google"
		},
		facebook: {
			button: "Iniciar sesión con Facebook",
			signup_button: "Registrarse con Facebook"
		},
		telegram: {
			button: "Iniciar sesión con Telegram",
			signup_button: "Registrarse con Telegram",
			loading: "Cargando Telegram...",
			load_timeout: "El widget de Telegram no pudo cargarse. Intenta recargar la página."
		},
		errors: {
			provider_denied: "Acceso denegado: {{error}}",
			unknown_provider: "Proveedor de autenticación desconocido",
			missing_code: "Código de autorización faltante",
			telegram_no_redirect: "Telegram no soporta flujo de redirección",
			popup_blocked: "La ventana emergente fue bloqueada. Permita ventanas emergentes e intente de nuevo.",
			network: "Error de red. Verifique su conexión.",
			generic: "Error de autenticación. Por favor, intente de nuevo."
		}
	}
}, jr = {
	login: {
		modal_title: "Sign in",
		page_title: "Sign in",
		page_subtitle: "Log in to your account",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Your password",
		submit: "Sign in",
		remember_me: "Remember me",
		forgot_password: "Forgot password?",
		no_account: "Don't have an account? Sign up",
		error_title: "Authentication error",
		help_text: "Having trouble signing in? Contact the administrator.",
		success_title: "Welcome!",
		success_message: "You have signed in successfully",
		or_with_email: "or with email",
		method_password: "Password",
		method_code: "Email Code",
		send_code: "Send login code",
		code: "Verification code",
		verify_and_sign_in: "Verify & Sign in",
		resend_code: "Resend code",
		code_sent: "Code sent to your email",
		errors: {
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			password_required: "Password is required",
			invalid_credentials: "Invalid email or password",
			account_locked: "Your account is locked. Contact the administrator.",
			account_disabled: "Your account is disabled",
			email_not_verified: "Please verify your email address",
			generic: "An error occurred. Please try again.",
			code_invalid: "Code must be 6 digits",
			code_send_failed: "Failed to send code. Please try again.",
			code_expired: "Code expired. Please request a new one.",
			code_rate_limited: "Too many attempts. Please wait 5 minutes.",
			code_invalid_value: "Invalid code. {{remaining}} attempts remaining."
		}
	},
	register: {
		modal_title: "Create account",
		page_title: "Sign up",
		page_subtitle: "Create your account",
		name_label: "Full name",
		name_placeholder: "John Doe",
		email_label: "Email",
		email_placeholder: "your@email.com",
		password_label: "Password",
		password_placeholder: "Minimum 8 characters",
		confirm_password_label: "Confirm password",
		confirm_password_placeholder: "Repeat your password",
		terms_prefix: "I accept the",
		terms_link: "Terms and Conditions",
		terms_and: "and the",
		privacy_link: "Privacy Policy",
		submit: "Create account",
		have_account: "Already have an account? Sign in",
		or_email: "or with email",
		error_title: "Registration error",
		errors: {
			name_required: "Name is required",
			name_too_long: "Name is too long (maximum 100 characters)",
			email_required: "Email is required",
			email_invalid: "Invalid email address",
			email_exists: "An account with this email already exists",
			password_min_length: "Password must be at least 8 characters",
			password_uppercase: "Password must contain at least one uppercase letter",
			password_lowercase: "Password must contain at least one lowercase letter",
			password_number: "Password must contain at least one number",
			confirm_password_required: "Please confirm your password",
			passwords_mismatch: "Passwords do not match",
			terms_required: "You must accept the terms and conditions",
			validation_error: "Validation error. Please check the fields.",
			rate_limited: "Too many attempts. Please try again later.",
			generic: "An error occurred. Please try again."
		},
		verification: {
			title: "Verify your email",
			message: "We've sent a verification link to {{email}}. Please check your inbox.",
			resend_button: "Resend verification email",
			resend_sent: "Email sent",
			resend_success: "We've resent the verification email.",
			resend_error: "Failed to resend. Please try again.",
			back_to_login: "Back to sign in"
		}
	},
	password: {
		strength: {
			label: "Password strength",
			weak: "Weak",
			fair: "Fair",
			good: "Good",
			strong: "Strong"
		},
		requirements: {
			length: "Minimum 8 characters",
			uppercase: "At least one uppercase letter",
			lowercase: "At least one lowercase letter",
			number: "At least one number"
		}
	},
	guard: {
		loading: "Checking authentication...",
		unauthorized_title: "Access Denied",
		unauthorized_message: "You don't have permission to access this page.",
		go_back: "Go Back",
		go_home: "Go Home"
	},
	userMenu: {
		menuLabel: "User menu",
		profile: "My Profile",
		orders: "My Orders",
		finances: "My Finances",
		logout: "Log out",
		logoutConfirmTitle: "Log out",
		logoutConfirmMessage: "Are you sure you want to log out?",
		cancel: "Cancel",
		logout_success_title: "Logged out",
		logout_success_message: "You have logged out successfully"
	},
	portal: {
		title: "Sign in to TeleTienda",
		register_title: "Create TeleTienda Account",
		continue_to: "to continue to {{domain}}",
		redirecting: "Redirecting to {{domain}}...",
		code_error: "Failed to complete authentication. Please try again."
	},
	oauth: {
		divider: "or continue with",
		processing: "Signing you in...",
		error_title: "Authentication Failed",
		google: {
			button: "Sign in with Google",
			signup_button: "Sign up with Google"
		},
		facebook: {
			button: "Sign in with Facebook",
			signup_button: "Sign up with Facebook"
		},
		telegram: {
			button: "Log in with Telegram",
			signup_button: "Sign up with Telegram",
			loading: "Loading Telegram...",
			load_timeout: "Telegram widget could not load. Try refreshing the page."
		},
		errors: {
			provider_denied: "Access was denied by {{error}}",
			unknown_provider: "Unknown authentication provider",
			missing_code: "Missing authorization code",
			telegram_no_redirect: "Telegram does not support redirect flow",
			popup_blocked: "Popup was blocked. Please allow popups and try again.",
			network: "Network error. Please check your connection.",
			generic: "Authentication failed. Please try again."
		}
	}
}, Mr = {
	login: {
		modal_title: "Вход",
		page_title: "Вход в систему",
		page_subtitle: "Войдите в свой аккаунт",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Ваш пароль",
		submit: "Войти",
		remember_me: "Запомнить меня",
		forgot_password: "Забыли пароль?",
		no_account: "Нет аккаунта? Зарегистрируйтесь",
		error_title: "Ошибка авторизации",
		help_text: "Проблемы со входом? Свяжитесь с администратором.",
		success_title: "Добро пожаловать!",
		success_message: "Вы успешно вошли в систему",
		or_with_email: "или по email",
		method_password: "Пароль",
		method_code: "Код на email",
		send_code: "Отправить код входа",
		code: "Код подтверждения",
		verify_and_sign_in: "Подтвердить и войти",
		resend_code: "Отправить код ещё раз",
		code_sent: "Код отправлен на ваш email",
		errors: {
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			password_required: "Пароль обязателен",
			invalid_credentials: "Неверный email или пароль",
			account_locked: "Ваш аккаунт заблокирован. Свяжитесь с администратором.",
			account_disabled: "Ваш аккаунт отключен",
			email_not_verified: "Пожалуйста, подтвердите ваш email",
			generic: "Произошла ошибка. Попробуйте снова.",
			code_invalid: "Код должен содержать 6 цифр",
			code_send_failed: "Не удалось отправить код. Попробуйте снова.",
			code_expired: "Код истёк. Запросите новый.",
			code_rate_limited: "Слишком много попыток. Подождите 5 минут.",
			code_invalid_value: "Неверный код. Осталось попыток: {{remaining}}."
		}
	},
	register: {
		modal_title: "Создать аккаунт",
		page_title: "Регистрация",
		page_subtitle: "Создайте свой аккаунт",
		name_label: "Полное имя",
		name_placeholder: "Иван Иванов",
		email_label: "Электронная почта",
		email_placeholder: "ваш@email.com",
		password_label: "Пароль",
		password_placeholder: "Минимум 8 символов",
		confirm_password_label: "Подтвердите пароль",
		confirm_password_placeholder: "Повторите пароль",
		terms_prefix: "Я принимаю",
		terms_link: "Условия использования",
		terms_and: "и",
		privacy_link: "Политику конфиденциальности",
		submit: "Создать аккаунт",
		have_account: "Уже есть аккаунт? Войти",
		or_email: "или по email",
		error_title: "Ошибка регистрации",
		errors: {
			name_required: "Имя обязательно",
			name_too_long: "Имя слишком длинное (максимум 100 символов)",
			email_required: "Email обязателен",
			email_invalid: "Неверный формат email",
			email_exists: "Аккаунт с таким email уже существует",
			password_min_length: "Пароль должен содержать минимум 8 символов",
			password_uppercase: "Пароль должен содержать хотя бы одну заглавную букву",
			password_lowercase: "Пароль должен содержать хотя бы одну строчную букву",
			password_number: "Пароль должен содержать хотя бы одну цифру",
			confirm_password_required: "Подтвердите пароль",
			passwords_mismatch: "Пароли не совпадают",
			terms_required: "Вы должны принять условия использования",
			validation_error: "Ошибка валидации. Проверьте поля.",
			rate_limited: "Слишком много попыток. Попробуйте позже.",
			generic: "Произошла ошибка. Попробуйте снова."
		},
		verification: {
			title: "Подтвердите email",
			message: "Мы отправили ссылку для подтверждения на {{email}}. Проверьте вашу почту.",
			resend_button: "Отправить письмо повторно",
			resend_sent: "Письмо отправлено",
			resend_success: "Мы повторно отправили письмо для подтверждения.",
			resend_error: "Не удалось отправить. Попробуйте снова.",
			back_to_login: "Вернуться к входу"
		}
	},
	password: {
		strength: {
			label: "Надежность пароля",
			weak: "Слабый",
			fair: "Средний",
			good: "Хороший",
			strong: "Надежный"
		},
		requirements: {
			length: "Минимум 8 символов",
			uppercase: "Хотя бы одна заглавная буква",
			lowercase: "Хотя бы одна строчная буква",
			number: "Хотя бы одна цифра"
		}
	},
	guard: {
		loading: "Проверка аутентификации...",
		unauthorized_title: "Доступ Запрещен",
		unauthorized_message: "У вас нет прав для доступа к этой странице.",
		go_back: "Назад",
		go_home: "На Главную"
	},
	userMenu: {
		menuLabel: "Меню пользователя",
		profile: "Мой Профиль",
		orders: "Мои Заказы",
		finances: "Мои Финансы",
		logout: "Выйти",
		logoutConfirmTitle: "Выход из системы",
		logoutConfirmMessage: "Вы уверены, что хотите выйти?",
		cancel: "Отмена",
		logout_success_title: "Вы вышли",
		logout_success_message: "Вы успешно вышли из системы"
	},
	portal: {
		title: "Вход в TeleTienda",
		register_title: "Создать аккаунт TeleTienda",
		continue_to: "для продолжения на {{domain}}",
		redirecting: "Перенаправление на {{domain}}...",
		code_error: "Не удалось завершить авторизацию. Пожалуйста, попробуйте снова."
	},
	oauth: {
		divider: "или продолжить через",
		processing: "Выполняется вход...",
		error_title: "Ошибка аутентификации",
		google: {
			button: "Войти через Google",
			signup_button: "Зарегистрироваться через Google"
		},
		facebook: {
			button: "Войти через Facebook",
			signup_button: "Зарегистрироваться через Facebook"
		},
		telegram: {
			button: "Войти через Telegram",
			signup_button: "Зарегистрироваться через Telegram",
			loading: "Загрузка Telegram...",
			load_timeout: "Виджет Telegram не загрузился. Попробуйте обновить страницу."
		},
		errors: {
			provider_denied: "Доступ запрещен: {{error}}",
			unknown_provider: "Неизвестный провайдер аутентификации",
			missing_code: "Отсутствует код авторизации",
			telegram_no_redirect: "Telegram не поддерживает перенаправление",
			popup_blocked: "Всплывающее окно заблокировано. Разрешите всплывающие окна и попробуйте снова.",
			network: "Ошибка сети. Проверьте подключение.",
			generic: "Ошибка аутентификации. Попробуйте снова."
		}
	}
}, Nr = {
	login: {
		modal_title: "Entrar",
		page_title: "Entrar",
		page_subtitle: "Acesse sua conta",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Sua senha",
		submit: "Entrar",
		remember_me: "Lembrar-me",
		forgot_password: "Esqueceu a senha?",
		no_account: "Não tem conta? Cadastre-se",
		error_title: "Erro de autenticação",
		help_text: "Problemas para entrar? Entre em contato com o administrador.",
		success_title: "Bem-vindo!",
		success_message: "Você entrou com sucesso",
		or_with_email: "ou com e-mail",
		method_password: "Senha",
		method_code: "Código por e-mail",
		send_code: "Enviar código de acesso",
		code: "Código de verificação",
		verify_and_sign_in: "Verificar e entrar",
		resend_code: "Reenviar código",
		code_sent: "Código enviado para seu e-mail",
		errors: {
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			password_required: "A senha é obrigatória",
			invalid_credentials: "E-mail ou senha incorretos",
			account_locked: "Sua conta está bloqueada. Entre em contato com o administrador.",
			account_disabled: "Sua conta está desativada",
			email_not_verified: "Por favor, verifique seu e-mail",
			generic: "Ocorreu um erro. Tente novamente.",
			code_invalid: "O código deve ter 6 dígitos",
			code_send_failed: "Erro ao enviar o código. Tente novamente.",
			code_expired: "Código expirado. Solicite um novo.",
			code_rate_limited: "Muitas tentativas. Aguarde 5 minutos.",
			code_invalid_value: "Código inválido. {{remaining}} tentativas restantes."
		}
	},
	register: {
		modal_title: "Criar conta",
		page_title: "Cadastrar",
		page_subtitle: "Crie sua conta",
		name_label: "Nome completo",
		name_placeholder: "João Silva",
		email_label: "E-mail",
		email_placeholder: "seu@email.com",
		password_label: "Senha",
		password_placeholder: "Mínimo 8 caracteres",
		confirm_password_label: "Confirmar senha",
		confirm_password_placeholder: "Repita sua senha",
		terms_prefix: "Eu aceito os",
		terms_link: "Termos e Condições",
		terms_and: "e a",
		privacy_link: "Política de Privacidade",
		submit: "Criar conta",
		have_account: "Já tem uma conta? Entrar",
		or_email: "ou com e-mail",
		error_title: "Erro de cadastro",
		errors: {
			name_required: "O nome é obrigatório",
			name_too_long: "O nome é muito longo (máximo 100 caracteres)",
			email_required: "O e-mail é obrigatório",
			email_invalid: "E-mail inválido",
			email_exists: "Já existe uma conta com este e-mail",
			password_min_length: "A senha deve ter pelo menos 8 caracteres",
			password_uppercase: "A senha deve conter pelo menos uma letra maiúscula",
			password_lowercase: "A senha deve conter pelo menos uma letra minúscula",
			password_number: "A senha deve conter pelo menos um número",
			confirm_password_required: "Por favor, confirme sua senha",
			passwords_mismatch: "As senhas não coincidem",
			terms_required: "Você deve aceitar os termos e condições",
			validation_error: "Erro de validação. Verifique os campos.",
			rate_limited: "Muitas tentativas. Tente novamente mais tarde.",
			generic: "Ocorreu um erro. Tente novamente."
		},
		verification: {
			title: "Verifique seu e-mail",
			message: "Enviamos um link de verificação para {{email}}. Por favor, verifique sua caixa de entrada.",
			resend_button: "Reenviar e-mail de verificação",
			resend_sent: "E-mail enviado",
			resend_success: "Reenviamos o e-mail de verificação.",
			resend_error: "Falha ao reenviar. Tente novamente.",
			back_to_login: "Voltar para entrar"
		}
	},
	password: {
		strength: {
			label: "Força da senha",
			weak: "Fraca",
			fair: "Regular",
			good: "Boa",
			strong: "Forte"
		},
		requirements: {
			length: "Mínimo 8 caracteres",
			uppercase: "Pelo menos uma letra maiúscula",
			lowercase: "Pelo menos uma letra minúscula",
			number: "Pelo menos um número"
		}
	},
	guard: {
		loading: "Verificando autenticação...",
		unauthorized_title: "Acesso Negado",
		unauthorized_message: "Você não tem permissão para acessar esta página.",
		go_back: "Voltar",
		go_home: "Ir para Início"
	},
	userMenu: {
		menuLabel: "Menu do usuário",
		profile: "Meu Perfil",
		orders: "Meus Pedidos",
		finances: "Minhas Finanças",
		logout: "Sair",
		logoutConfirmTitle: "Sair",
		logoutConfirmMessage: "Tem certeza de que deseja sair?",
		cancel: "Cancelar",
		logout_success_title: "Sessão encerrada",
		logout_success_message: "Você saiu com sucesso"
	},
	portal: {
		title: "Entrar na TeleTienda",
		register_title: "Criar conta TeleTienda",
		continue_to: "para continuar em {{domain}}",
		redirecting: "Redirecionando para {{domain}}...",
		code_error: "Falha ao completar a autenticação. Por favor, tente novamente."
	},
	oauth: {
		divider: "ou continuar com",
		processing: "Entrando...",
		error_title: "Falha na autenticação",
		google: {
			button: "Entrar com Google",
			signup_button: "Cadastrar com Google"
		},
		facebook: {
			button: "Entrar com Facebook",
			signup_button: "Cadastrar com Facebook"
		},
		telegram: {
			button: "Entrar com Telegram",
			signup_button: "Cadastrar com Telegram",
			loading: "Carregando Telegram...",
			load_timeout: "O widget do Telegram não pôde carregar. Tente recarregar a página."
		},
		errors: {
			provider_denied: "Acesso negado: {{error}}",
			unknown_provider: "Provedor de autenticação desconhecido",
			missing_code: "Código de autorização ausente",
			telegram_no_redirect: "O Telegram não suporta fluxo de redirecionamento",
			popup_blocked: "A janela pop-up foi bloqueada. Permita pop-ups e tente novamente.",
			network: "Erro de rede. Verifique sua conexão.",
			generic: "Falha na autenticação. Tente novamente."
		}
	}
}, Pr = [
	"es",
	"en",
	"ru",
	"pt"
], Fr = "es", Ir = {
	es: { auth: Ar },
	en: { auth: jr },
	ru: { auth: Mr },
	pt: { auth: Nr }
};
function Lr(e) {
	return Ir[e];
}
function Rr(e) {
	for (let t of Pr) e.addResourceBundle(t, "auth", Ir[t].auth, !0, !1);
}
//#endregion
export { wt as AUTH_STORAGE_NAME, X as AuthApiError, Cr as AuthCallbackPage, hr as AuthGuard, Sr as AuthProvider, Ee as COOKIE_MAX_AGE, at as COOKIE_MAX_SIZE, it as COOKIE_WARNING_THRESHOLD, we as CROSS_SUBDOMAIN_SYNC_COOKIE, Te as CROSS_SUBDOMAIN_SYNC_INTERVAL, Fr as DEFAULT_LANGUAGE, Rn as FacebookLoginButton, Ln as GoogleLoginButton, or as LoadingFallback, Un as LoginForm, Kn as LoginModal, qn as LoginPage, e as PLATFORM_ADMIN_ROLES, De as PRODUCTION_DOMAIN, $n as PasswordStrengthIndicator, gr as ProtectedRoute, sr as RETURN_URL_PARAM, tr as RegisterForm, rr as RegisterModal, rt as SLIM_AUTH_COOKIE_NAME, Se as STORAGE_KEY, Pr as SUPPORTED_LANGUAGES, Ce as SYNC_CHANNEL_NAME, Bn as SocialLoginButtons, zn as TelegramLoginButton, ar as UnauthorizedFallback, _r as UserAvatar, yr as UserMenu, nr as VerificationSuccess, Rr as addAuthTranslations, Re as areCookiesEnabled, on as authFetch, Ir as authTranslations, et as broadcastCrossSubdomainLogin, tt as broadcastCrossSubdomainLogout, nt as broadcastCrossSubdomainTokenRefresh, Ke as broadcastLogin, qe as broadcastLogout, Je as broadcastTokenRefresh, ur as buildRedirectUrl, Yn as calculatePasswordStrength, Jn as checkPasswordRequirements, mt as checkStorageHealth, Y as clearAuthStorage, dt as configureAuthApi, rn as configureHttpClient, Ot as createAuthStoreSlice, en as createAuthenticatedClient, Ct as createZustandStorage, Tr as decodeToken, Le as deleteCookie, H as deleteSlimCookie, qt as facebookOAuthCallbackApi, Z as fetchUserProfileApi, W as getApiClient, ft as getApiConfig, K as getAuthStorage, Lr as getAuthTranslations, Fe as getCookie, Be as getCookieJSON, ct as getCookieSizeInfo, Ze as getCrossSubdomainSync, Ue as getCrossTabSync, fr as getCurrentPath, an as getHttpClient, pn as getRefreshPromise, dr as getReturnUrl, V as getSlimCookie, B as getStorageConfig, Rt as getStorageHealth, Xn as getStrengthColor, Zn as getStrengthLabel, Er as getTokenExpiration, kr as getTokenTTL, Or as getUserGuidFromToken, Kt as googleOAuthCallbackApi, vt as hasFullUserData, _t as hydrateFromApi, Ft as initAuthSync, yt as isHydrationNeeded, ht as isPrivateBrowsing, mr as isRedirectLoop, ot as isSlimAuthData, Lt as isTokenExpired, Dr as isTokenExpiredFromString, lr as isValidReturnUrl, Bt as loginApi, Gt as loginByCodeApi, Vn as loginSchema, Ut as logoutApi, It as needsTokenRefresh, Ge as onAuthSync, $e as onCrossSubdomainSync, Pe as parseCookies, pr as performRedirect, Ht as refreshTokenApi, Vt as registerApi, er as registerSchema, Wt as requestLoginCodeApi, St as resetAuthStorage, Qe as resetCrossSubdomainSync, We as resetCrossTabSync, Zt as resetHttpClientState, mn as resetRefreshPromise, Ne as resetStorageConfig, Pt as retryInitialHydration, Ie as setCookie, ze as setCookieJSON, lt as setSlimCookie, Et as setStorageAdapter, Me as setStorageConfig, pt as setTokenGetter, Jt as telegramOAuthCallbackApi, G as transformApiUser, sn as useAuth, xr as useAuthContext, ln as useAuthGuard, J as useAuthStore, Sn as useFacebookAuth, xn as useGoogleAuth, cn as useHasHydrated, Cn as useTelegramAuth, hn as useTokenRefresh };

//# sourceMappingURL=index.es.js.map